"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SeafileAPI = void 0;

require("core-js/modules/es6.array.is-array.js");

require("core-js/modules/es6.array.for-each.js");

require("core-js/modules/es6.function.name.js");

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.object.define-property.js");

var _axios = _interopRequireDefault(require("axios"));

var _formData = _interopRequireDefault(require("form-data"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SeafileAPI = /*#__PURE__*/function () {
  function SeafileAPI() {
    _classCallCheck(this, SeafileAPI);
  }

  _createClass(SeafileAPI, [{
    key: "init",
    value: function init(_ref) {
      var server = _ref.server,
          username = _ref.username,
          password = _ref.password,
          token = _ref.token;
      this.server = server;
      this.username = username;
      this.password = password;
      this.token = token; //none

      if (this.token && this.server) {
        this.req = _axios["default"].create({
          baseURL: this.server,
          headers: {
            'Authorization': 'Token ' + this.token
          }
        });
      }

      return this;
    }
  }, {
    key: "initForSeahubUsage",
    value: function initForSeahubUsage(_ref2) {
      var siteRoot = _ref2.siteRoot,
          xcsrfHeaders = _ref2.xcsrfHeaders;

      if (siteRoot && siteRoot.charAt(siteRoot.length - 1) === "/") {
        var server = siteRoot.substring(0, siteRoot.length - 1);
        this.server = server;
      } else {
        this.server = siteRoot;
      }

      this.req = _axios["default"].create({
        headers: {
          'X-CSRFToken': xcsrfHeaders
        }
      });
      return this;
    }
  }, {
    key: "_sendPostRequest",
    value: function _sendPostRequest(url, form) {
      if (form.getHeaders) {
        return this.req.post(url, form, {
          headers: form.getHeaders()
        });
      } else {
        return this.req.post(url, form);
      }
    }
  }, {
    key: "getToken",
    value: function getToken() {
      var _this = this;

      var url = this.server + '/api2/auth-token/';

      _axios["default"].post(url, {
        username: this.username,
        password: this.password
      }).then(function (response) {
        _this.token = response.data;
        return _this.token;
      });
    }
  }, {
    key: "getAuthTokenBySession",
    value: function getAuthTokenBySession() {
      var url = this.server + '/api/v2.1/auth-token-by-session/';
      return this.req.get(url);
    }
  }, {
    key: "createAuthTokenBySession",
    value: function createAuthTokenBySession() {
      var url = this.server + '/api/v2.1/auth-token-by-session/';
      return this.req.post(url);
    }
  }, {
    key: "deleteAuthTokenBySession",
    value: function deleteAuthTokenBySession() {
      var url = this.server + '/api/v2.1/auth-token-by-session/';
      return this.req["delete"](url);
    }
    /**
     * Login to server and create axios instance for future usage
     */

  }, {
    key: "login",
    value: function login() {
      var _this2 = this;

      var url = this.server + '/api2/auth-token/';
      return _axios["default"].post(url, {
        username: this.username,
        password: this.password
      }).then(function (response) {
        _this2.token = response.data.token;
        _this2.req = _axios["default"].create({
          baseURL: _this2.server,
          headers: {
            'Authorization': 'Token ' + _this2.token
          }
        });
      });
    }
  }, {
    key: "authPing",
    value: function authPing() {
      var url = this.server + '/api2/auth/ping/';
      return this.req.get(url);
    } //---- Account API

  }, {
    key: "getAccountInfo",
    value: function getAccountInfo() {
      var url = this.server + '/api2/account/info/';
      return this.req.get(url);
    } //---- Group operation

  }, {
    key: "listDepartments",
    value: function listDepartments() {
      var url = this.server + '/api/v2.1/departments/';
      return this.req.get(url);
    }
  }, {
    key: "listGroups",
    value: function listGroups() {
      var withRepos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var options = {
        with_repos: withRepos ? 1 : 0
      };
      var url = this.server + '/api/v2.1/groups/';
      return this.req.get(url, {
        params: options
      });
    }
  }, {
    key: "listGroupRepos",
    value: function listGroupRepos(groupID, page, perPage) {
      var url = this.server + '/api/v2.1/groups/' + groupID + '/libraries/';
      var params = {};

      if (page != undefined) {
        params.page = page;
      }

      if (perPage != undefined) {
        params.per_page = perPage;
      }

      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "getGroup",
    value: function getGroup(groupID) {
      var url = this.server + '/api/v2.1/groups/' + groupID + '/';
      return this.req.get(url);
    }
  }, {
    key: "createGroup",
    value: function createGroup(name) {
      var url = this.server + '/api/v2.1/groups/';
      var form = new _formData["default"]();
      form.append('name', name);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "renameGroup",
    value: function renameGroup(groupID, name) {
      var url = this.server + '/api/v2.1/groups/' + groupID + '/';
      var params = {
        name: name
      };
      return this.req.put(url, params);
    }
  }, {
    key: "deleteGroup",
    value: function deleteGroup(groupID) {
      var url = this.server + '/api/v2.1/groups/' + groupID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "transferGroup",
    value: function transferGroup(groupID, ownerName) {
      var url = this.server + '/api/v2.1/groups/' + groupID + '/';
      var params = {
        owner: ownerName
      };
      return this.req.put(url, params);
    }
  }, {
    key: "quitGroup",
    value: function quitGroup(groupID, userName) {
      var name = encodeURIComponent(userName);
      var url = this.server + '/api/v2.1/groups/' + groupID + '/members/' + name + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "listGroupMembers",
    value: function listGroupMembers(groupID, page, perPage) {
      var isAdmin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var avatarSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 64;
      var url = this.server + '/api/v2.1/groups/' + groupID + '/members/';
      var params = {
        page: page || 1,
        per_page: perPage || 100,
        is_admin: isAdmin,
        avatar_size: avatarSize
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "searchGroupMember",
    value: function searchGroupMember(groupID, q) {
      var url = this.server + '/api/v2.1/groups/' + groupID + '/search-member/';
      var params = {
        q: q
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "addGroupMember",
    value: function addGroupMember(groupID, userName) {
      var url = this.server + '/api/v2.1/groups/' + groupID + '/members/';
      var params = {
        email: userName
      };
      return this.req.post(url, params);
    }
  }, {
    key: "addGroupMembers",
    value: function addGroupMembers(groupID, userNames) {
      var url = this.server + '/api/v2.1/groups/' + groupID + '/members/bulk/';
      var form = new _formData["default"]();
      form.append('emails', userNames.join(','));
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "importGroupMembersViaFile",
    value: function importGroupMembersViaFile(groupID, file) {
      var url = this.server + '/api/v2.1/groups/' + groupID + '/members/import/';
      var formData = new _formData["default"]();
      formData.append('file', file);
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "deleteGroupMember",
    value: function deleteGroupMember(groupID, userName) {
      var name = encodeURIComponent(userName);
      var url = this.server + '/api/v2.1/groups/' + groupID + '/members/' + name + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "setGroupAdmin",
    value: function setGroupAdmin(groupID, userName, isAdmin) {
      var name = encodeURIComponent(userName);
      var url = this.server + '/api/v2.1/groups/' + groupID + '/members/' + name + '/';
      var params = {
        is_admin: isAdmin
      };
      return this.req.put(url, params);
    }
  }, {
    key: "createGroupOwnedLibrary",
    value: function createGroupOwnedLibrary(groupID, repo) {
      var repoName = repo.repo_name;
      var permission = repo.permission ? repo.permission : 'rw';
      var url = this.server + '/api/v2.1/groups/' + groupID + '/group-owned-libraries/';
      var form = new _formData["default"]();
      form.append('name', repoName); // need to modify endpoint api;

      if (repo.passwd) {
        form.append("passwd", repo.passwd);
      }

      form.append('permission', permission);

      if (repo.library_template) {
        form.append("library_template", repo.library_template);
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "deleteGroupOwnedLibrary",
    value: function deleteGroupOwnedLibrary(groupID, repoID) {
      var url = this.server + '/api/v2.1/groups/' + groupID + '/group-owned-libraries/' + repoID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "renameGroupOwnedLibrary",
    value: function renameGroupOwnedLibrary(groupID, repoID, newName) {
      var url = this.server + '/api/v2.1/groups/' + groupID + '/group-owned-libraries/' + repoID + '/';
      var form = new _formData["default"]();
      form.append('name', newName);
      return this.req.put(url, form);
    }
  }, {
    key: "shareGroupOwnedRepoToUser",
    value: function shareGroupOwnedRepoToUser(repoID, permission, username, path) {
      var url = this.server + '/api/v2.1/group-owned-libraries/' + repoID + '/user-share/';
      var form = new _formData["default"]();
      form.append('permission', permission);
      form.append('path', path);

      if (Array.isArray(username)) {
        username.forEach(function (item) {
          form.append('username', item);
        });
      } else {
        form.append('username', username);
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "modifyGroupOwnedRepoUserSharedPermission",
    value: function modifyGroupOwnedRepoUserSharedPermission(repoID, permission, username, path) {
      //need check
      var url = this.server + '/api/v2.1/group-owned-libraries/' + repoID + '/user-share/';
      var form = new _formData["default"]();
      form.append('permission', permission);
      form.append('username', username);
      form.append('path', path);
      return this.req.put(url, form);
    }
  }, {
    key: "deleteGroupOwnedRepoSharedUserItem",
    value: function deleteGroupOwnedRepoSharedUserItem(repoID, username, path) {
      var url = this.server + '/api/v2.1/group-owned-libraries/' + repoID + '/user-share/';
      var params = {
        username: username,
        path: path
      };
      return this.req["delete"](url, {
        data: params
      });
    }
  }, {
    key: "shareGroupOwnedRepoToGroup",
    value: function shareGroupOwnedRepoToGroup(repoID, permission, groupID, path) {
      var url = this.server + '/api/v2.1/group-owned-libraries/' + repoID + '/group-share/';
      var form = new _formData["default"]();
      form.append('permission', permission);
      form.append('path', path);

      if (Array.isArray(groupID)) {
        groupID.forEach(function (item) {
          form.append('group_id', item);
        });
      } else {
        form.append('group_id', groupID);
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "modifyGroupOwnedRepoGroupSharedPermission",
    value: function modifyGroupOwnedRepoGroupSharedPermission(repoID, permission, groupID, path) {
      //need check
      var url = this.server + '/api/v2.1/group-owned-libraries/' + repoID + '/group-share/';
      var form = new _formData["default"]();
      form.append('permission', permission);
      form.append('group_id', groupID);
      form.append('path', path);
      return this.req.put(url, form);
    }
  }, {
    key: "deleteGroupOwnedRepoSharedGroupItem",
    value: function deleteGroupOwnedRepoSharedGroupItem(repoID, groupID, path) {
      var url = this.server + '/api/v2.1/group-owned-libraries/' + repoID + '/group-share/';
      var params = {
        group_id: groupID,
        path: path
      };
      return this.req["delete"](url, {
        data: params
      });
    } //---- share operation
    // share-link

  }, {
    key: "listUserShareLinks",
    value: function listUserShareLinks() {
      var url = this.server + '/api/v2.1/share-links/';
      return this.req.get(url);
    }
  }, {
    key: "getShareLink",
    value: function getShareLink(repoID, filePath) {
      //list folder(file) links
      var path = encodeURIComponent(filePath);
      var url = this.server + '/api/v2.1/share-links/?repo_id=' + repoID + '&path=' + path;
      return this.req.get(url);
    }
  }, {
    key: "createMultiShareLink",
    value: function createMultiShareLink(repoID, path, password, expirationTime, permissions) {
      var url = this.server + '/api/v2.1/multi-share-links/';
      var form = new _formData["default"]();
      form.append('path', path);
      form.append('repo_id', repoID);

      if (permissions) {
        form.append('permissions', permissions);
      }

      if (password) {
        form.append('password', password);
      }

      if (expirationTime) {
        form.append('expiration_time', expirationTime);
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "batchCreateMultiShareLink",
    value: function batchCreateMultiShareLink(repoID, path, shareLinkNum, autoGeneratePassword, expirationTime, permissions) {
      var url = this.server + '/api/v2.1/multi-share-links/batch/';
      var form = new _formData["default"]();
      form.append('path', path);
      form.append('repo_id', repoID);
      form.append('number', shareLinkNum);
      form.append('auto_generate_password', autoGeneratePassword);

      if (permissions) {
        form.append('permissions', permissions);
      }

      if (expirationTime) {
        form.append('expiration_time', expirationTime);
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "createShareLink",
    value: function createShareLink(repoID, path, password, expirationTime, permissions) {
      var url = this.server + '/api/v2.1/share-links/';
      var form = new _formData["default"]();
      form.append('path', path);
      form.append('repo_id', repoID);

      if (permissions) {
        form.append('permissions', permissions);
      }

      if (password) {
        form.append('password', password);
      }

      if (expirationTime) {
        form.append('expiration_time', expirationTime);
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "updateShareLink",
    value: function updateShareLink(token, permissions) {
      var expirationTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var url = this.server + '/api/v2.1/share-links/' + token + '/';
      var form = new _formData["default"]();

      if (permissions) {
        form.append('permissions', permissions);
      }

      if (expirationTime) {
        form.append('expiration_time', expirationTime);
      }

      return this.req.put(url, form);
    }
  }, {
    key: "deleteShareLink",
    value: function deleteShareLink(token) {
      var url = this.server + '/api/v2.1/share-links/' + token + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "cleanInvalidShareLinks",
    value: function cleanInvalidShareLinks() {
      var url = this.server + '/api/v2.1/share-links/clean-invalid/';
      return this.req["delete"](url);
    }
  }, {
    key: "sendShareLink",
    value: function sendShareLink(token, email, extraMsg) {
      var url = this.server + '/api2/send-share-link/';
      var form = new _formData["default"]();
      form.append('token', token);
      form.append('email', email);

      if (extraMsg) {
        form.append('extra_msg', extraMsg);
      }

      return this._sendPostRequest(url, form);
    } // for repo & folder

  }, {
    key: "getRepoFolderShareInfo",
    value: function getRepoFolderShareInfo(repoID, path) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/share-info/';
      var params = {};

      if (path != undefined) {
        params.path = path;
      }

      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "listRepoShareLinks",
    value: function listRepoShareLinks(repoID) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/share-links/';
      return this.req.get(url);
    }
  }, {
    key: "deleteRepoShareLink",
    value: function deleteRepoShareLink(repoID, token) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/share-links/' + token + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "listSharedRepos",
    value: function listSharedRepos() {
      var url = this.server + '/api/v2.1/shared-repos/';
      return this.req.get(url);
    }
  }, {
    key: "getShareLinkRepoTags",
    value: function getShareLinkRepoTags(token) {
      var url = this.server + '/api/v2.1/share-links/' + token + '/repo-tags/';
      return this.req.get(url);
    }
  }, {
    key: "getShareLinkTaggedFiles",
    value: function getShareLinkTaggedFiles(token, tag_id) {
      var url = this.server + '/api/v2.1/share-links/' + token + '/tagged-files/' + tag_id + '/';
      return this.req.get(url);
    } // upload-link

  }, {
    key: "listUserUploadLinks",
    value: function listUserUploadLinks() {
      var url = this.server + '/api/v2.1/upload-links/';
      return this.req.get(url);
    }
  }, {
    key: "getUploadLink",
    value: function getUploadLink(repoID, path) {
      var url = this.server + '/api/v2.1/upload-links/?repo_id=' + repoID + '&path=' + encodeURIComponent(path);
      return this.req.get(url);
    }
  }, {
    key: "createUploadLink",
    value: function createUploadLink(repoID, path, password, expirationTime) {
      var url = this.server + '/api/v2.1/upload-links/';
      var form = new _formData["default"]();
      form.append('path', path);
      form.append('repo_id', repoID);

      if (password) {
        form.append('password', password);
      }

      if (expirationTime) {
        form.append('expiration_time', expirationTime);
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "updateUploadLink",
    value: function updateUploadLink(token, expirationTime) {
      var url = this.server + '/api/v2.1/upload-links/' + token + '/';
      var form = new _formData["default"]();
      form.append('expiration_time', expirationTime);
      return this.req.put(url, form);
    }
  }, {
    key: "deleteUploadLink",
    value: function deleteUploadLink(token) {
      var url = this.server + '/api/v2.1/upload-links/' + token + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "cleanInvalidUploadLinks",
    value: function cleanInvalidUploadLinks() {
      var url = this.server + '/api/v2.1/upload-links/clean-invalid/';
      return this.req["delete"](url);
    }
  }, {
    key: "sendUploadLink",
    value: function sendUploadLink(token, email, extraMsg) {
      var url = this.server + '/api2/send-upload-link/';
      var form = new _formData["default"]();
      form.append('token', token);
      form.append('email', email);

      if (extraMsg) {
        form.append('extra_msg', extraMsg);
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "listRepoUploadLinks",
    value: function listRepoUploadLinks(repoID) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/upload-links/';
      return this.req.get(url);
    }
  }, {
    key: "deleteRepoUploadLink",
    value: function deleteRepoUploadLink(repoID, token) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/upload-links/' + token + '/';
      return this.req["delete"](url);
    } // todo send upload link email
    // shared-libraries

  }, {
    key: "listSharedItems",
    value: function listSharedItems(repoID, path, shareType) {
      // shareType: user, group
      path = encodeURIComponent(path);
      var url = this.server + '/api2/repos/' + repoID + '/dir/shared_items/?p=' + path + '&share_type=' + shareType;
      return this.req.get(url);
    }
  }, {
    key: "getBeSharedRepos",
    value: function getBeSharedRepos() {
      //listBeSharedRepos
      var url = this.server + '/api2/beshared-repos/';
      return this.req.get(url);
    }
  }, {
    key: "leaveShareRepo",
    value: function leaveShareRepo(repoID, options) {
      // deleteBeSharedRepo
      var url = this.server + '/api2/beshared-repos/' + repoID + '/';
      return this.req["delete"](url, {
        params: options
      });
    } // share repo to user is same to share Folder
    // unshare repo to user is same to unshare Folder

  }, {
    key: "deleteShareToUserItem",
    value: function deleteShareToUserItem(repoID, path, shareType, username) {
      path = encodeURIComponent(path);
      var url = this.server + '/api2/repos/' + repoID + '/dir/shared_items/?p=' + path + '&share_type=' + shareType + '&username=' + encodeURIComponent(username);
      return this.req["delete"](url);
    }
  }, {
    key: "updateShareToUserItemPermission",
    value: function updateShareToUserItemPermission(repoID, path, shareType, username, permission) {
      path = encodeURIComponent(path);
      var url = this.server + '/api2/repos/' + repoID + '/dir/shared_items/?p=' + path + '&share_type=' + shareType + '&username=' + encodeURIComponent(username);
      var form = new _formData["default"]();
      form.append('permission', permission);
      return this._sendPostRequest(url, form);
    } // share repo to group is same to share folder
    // unshare repo to group is same to unshare folder

  }, {
    key: "deleteShareToGroupItem",
    value: function deleteShareToGroupItem(repoID, path, shareType, groupID) {
      path = encodeURIComponent(path);
      var url = this.server + '/api2/repos/' + repoID + '/dir/shared_items/?p=' + path + '&share_type=' + shareType + '&group_id=' + groupID;
      return this.req["delete"](url);
    }
  }, {
    key: "updateShareToGroupItemPermission",
    value: function updateShareToGroupItemPermission(repoID, path, shareType, groupID, permission) {
      path = encodeURIComponent(path);
      var url = this.server + '/api2/repos/' + repoID + '/dir/shared_items/?p=' + path + '&share_type=' + shareType + '&group_id=' + groupID;
      var form = new _formData["default"]();
      form.append('permission', permission);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "leaveShareGroupOwnedRepo",
    value: function leaveShareGroupOwnedRepo(repoID) {
      var url = this.server + '/api/v2.1/group-owned-libraries/user-share-in-libraries/' + repoID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "shareableGroups",
    value: function shareableGroups() {
      var url = this.server + '/api/v2.1/shareable-groups/';
      return this.req.get(url);
    }
  }, {
    key: "getSharedRepos",
    value: function getSharedRepos() {
      var url = this.server + '/api2/shared-repos/';
      return this.req.get(url);
    }
  }, {
    key: "updateRepoSharePerm",
    value: function updateRepoSharePerm(repoID, options) {
      var url = this.server + '/api/v2.1/shared-repos/' + repoID + '/';
      return this.req.put(url, options);
    }
  }, {
    key: "unshareRepo",
    value: function unshareRepo(repoID, options) {
      var url = this.server + '/api/v2.1/shared-repos/' + repoID + '/';
      return this.req["delete"](url, {
        params: options
      });
    }
  }, {
    key: "unshareRepoToGroup",
    value: function unshareRepoToGroup(repoID, groupID) {
      var url = this.server + '/api/v2.1/groups/' + groupID + '/libraries/' + repoID + '/';
      return this.req["delete"](url);
    } // shared folders

  }, {
    key: "shareFolder",
    value: function shareFolder(repoID, path, shareType, permission, paramArray) {
      // shareType: user group
      path = encodeURIComponent(path);
      var form = new _formData["default"]();
      form.append('share_type', shareType);
      form.append('permission', permission);

      if (shareType == 'user') {
        for (var i = 0; i < paramArray.length; i++) {
          form.append('username', paramArray[i]);
        }
      } else {
        for (var _i = 0; _i < paramArray.length; _i++) {
          form.append('group_id', paramArray[_i]);
        }
      }

      var url = this.server + '/api2/repos/' + repoID + '/dir/shared_items/?p=' + path;
      return this.req.put(url, form);
    }
  }, {
    key: "listSharedFolders",
    value: function listSharedFolders() {
      var url = this.server + '/api/v2.1/shared-folders/';
      return this.req.get(url);
    }
  }, {
    key: "updateFolderSharePerm",
    value: function updateFolderSharePerm(repoID, data, options) {
      var url = this.server + '/api2/repos/' + repoID + '/dir/shared_items/';
      return this.req.post(url, data, {
        params: options
      }); // due to the old api, use 'post' here
    }
  }, {
    key: "unshareFolder",
    value: function unshareFolder(repoID, options) {
      var url = this.server + '/api2/repos/' + repoID + '/dir/shared_items/';
      return this.req["delete"](url, {
        params: options
      });
    }
  }, {
    key: "listCustomPermissions",
    value: function listCustomPermissions(repoID) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/custom-share-permissions/';
      return this.req.get(url);
    }
  }, {
    key: "createCustomPermission",
    value: function createCustomPermission(repoID, permission_name, permission_desc, permission) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/custom-share-permissions/';
      var data = {
        permission_name: permission_name,
        description: permission_desc,
        permission: JSON.stringify(permission)
      };
      return this.req.post(url, data);
    }
  }, {
    key: "getCustomPermission",
    value: function getCustomPermission(repoID, permissionID) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/custom-share-permissions/' + permissionID + '/';
      return this.req.get(url);
    }
  }, {
    key: "deleteCustomPermission",
    value: function deleteCustomPermission(repoID, permissionID) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/custom-share-permissions/' + permissionID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "updateCustomPermission",
    value: function updateCustomPermission(repoID, permission) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/custom-share-permissions/' + permission.id + '/';
      var data = {
        permission_name: permission.name,
        description: permission.description,
        permission: JSON.stringify(permission.permission)
      };
      return this.req.put(url, data);
    } //---- repo(library) operation

  }, {
    key: "createMineRepo",
    value: function createMineRepo(repo) {
      var url = this.server + '/api2/repos/?from=web';
      return this.req.post(url, repo);
    }
  }, {
    key: "createGroupRepo",
    value: function createGroupRepo(groupID, repo) {
      var url = this.server + '/api/v2.1/groups/' + groupID + '/libraries/';
      var form = new _formData["default"]();
      form.append("repo_name", repo.repo_name);

      if (repo.password) {
        form.append("password", repo.password);
      }

      form.append("permission", repo.permission);

      if (repo.library_template) {
        form.append("library_template", repo.library_template);
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "listRepos",
    value: function listRepos(options) {
      /*
       * options: `{type: 'shared'}`, `{type: ['mine', 'shared', ...]}`
       */
      var url = this.server + '/api/v2.1/repos/';

      if (!options) {
        // fetch all types of repos
        return this.req.get(url);
      }

      return this.req.get(url, {
        params: options,
        paramsSerializer: {
          serialize: function serialize(params) {
            var list = [];

            for (var key in params) {
              if (Array.isArray(params[key])) {
                for (var i = 0, len = params[key].length; i < len; i++) {
                  list.push(key + '=' + encodeURIComponent(params[key][i]));
                }
              } else {
                list.push(key + '=' + encodeURIComponent(params[key]));
              }
            }

            return list.join('&');
          }
        }
      });
    }
  }, {
    key: "getRepoInfo",
    value: function getRepoInfo(repoID) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/';
      return this.req.get(url);
    }
  }, {
    key: "getRepoHistoryLimit",
    value: function getRepoHistoryLimit(repoID) {
      var url = this.server + '/api2/repos/' + repoID + '/history-limit/';
      return this.req.get(url);
    }
  }, {
    key: "setRepoHistoryLimit",
    value: function setRepoHistoryLimit(repoID, historyDays) {
      var url = this.server + '/api2/repos/' + repoID + '/history-limit/';
      var form = new _formData["default"]();
      form.append('keep_days', historyDays);
      return this.req.put(url, form);
    }
  }, {
    key: "resetAndSendEncryptedRepoPassword",
    value: function resetAndSendEncryptedRepoPassword(repoID) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/send-new-password/';
      var form = new _formData["default"]();
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "deleteRepo",
    value: function deleteRepo(repoID) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "renameRepo",
    value: function renameRepo(repoID, newName) {
      var url = this.server + '/api2/repos/' + repoID + '/?op=rename';
      var form = new _formData["default"]();
      form.append('repo_name', newName);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "transferRepo",
    value: function transferRepo(repoID, owner) {
      var url = this.server + '/api2/repos/' + repoID + '/owner/';
      var form = new _formData["default"]();
      form.append('owner', owner);
      return this.req.put(url, form);
    }
  }, {
    key: "setRepoDecryptPassword",
    value: function setRepoDecryptPassword(repoID, password) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/set-password/';
      var form = new _formData["default"]();
      form.append('password', password);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "changeEncryptedRepoPassword",
    value: function changeEncryptedRepoPassword(repoID, oldPassword, newPassword) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/set-password/';
      var data = {
        'old_password': oldPassword,
        'new_password': newPassword
      };
      return this.req.put(url, data);
    }
  }, {
    key: "createPublicRepo",
    value: function createPublicRepo(repo) {
      var url = this.server + '/api2/repos/public/';
      return this.req.post(url, repo);
    }
  }, {
    key: "selectOwnedRepoToPublic",
    value: function selectOwnedRepoToPublic(repoID, options) {
      // todo change a exist repo to public
      var url = this.server + '/api/v2.1/shared-repos/' + repoID + '/';
      return this.req.put(url, options);
    } // remove public repo is same to unshareRepo;

  }, {
    key: "getSource",
    value: function getSource() {
      // for search
      var CancelToken = _axios["default"].CancelToken;
      var source = CancelToken.source();
      return source;
    }
  }, {
    key: "searchFilesInPublishedRepo",
    value: function searchFilesInPublishedRepo(repoID, q, page, perPage) {
      var url = this.server + '/api/v2.1/published-repo-search/';
      var params = {
        repo_id: repoID,
        q: q,
        page: page,
        per_page: perPage
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "searchFiles",
    value: function searchFiles(searchParams, cancelToken) {
      var url = this.server + '/api2/search/';
      url = url + '?q=' + searchParams.q;

      if (searchParams.search_repo) {
        url = url + '&search_repo=' + searchParams.search_repo;
      }

      if (searchParams.search_ftypes) {
        url = url + '&search_ftypes=' + searchParams.search_ftypes;
      }

      if (searchParams.page) {
        url = url + '&page=' + searchParams.page;
      }

      if (searchParams.per_page) {
        url = url + '&per_page=' + searchParams.per_page;
      }

      if (searchParams.search_path) {
        url = url + '&search_path=' + searchParams.search_path;
      }

      if (searchParams.obj_type) {
        url = url + '&obj_type=' + searchParams.obj_type;
      }

      if (searchParams.input_fexts) {
        url = url + '&input_fexts=' + searchParams.input_fexts;
      }

      if (searchParams.with_permission) {
        url = url + '&with_permission=' + searchParams.with_permission;
      }

      if (searchParams.time_from) {
        url = url + '&time_from=' + searchParams.time_from;
      }

      if (searchParams.time_to) {
        url = url + '&time_to=' + searchParams.time_to;
      }

      if (searchParams.size_from) {
        url = url + '&size_from=' + searchParams.size_from;
      }

      if (searchParams.size_to) {
        url = url + '&size_to=' + searchParams.size_to;
      }

      if (searchParams.shared_from) {
        url = url + '&shared_from=' + searchParams.shared_from;
      }

      if (searchParams.not_shared_from) {
        url = url + '&not_shared_from=' + searchParams.not_shared_from;
      }

      if (searchParams.ftype) {
        for (var i = 0; i < searchParams.ftype.length; i++) {
          url = url + '&ftype=' + searchParams.ftype[i];
        }
      }

      return this.req.get(url, {
        cancelToken: cancelToken
      });
    }
  }, {
    key: "searchFileInRepo",
    value: function searchFileInRepo(repoID, q) {
      var url = this.server + '/api/v2.1/search-file/';
      var params = {
        repo_id: repoID,
        q: q
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "listRepoAPITokens",
    value: function listRepoAPITokens(repo_id) {
      var url = this.server + '/api/v2.1/repos/' + repo_id + '/repo-api-tokens/';
      return this.req.get(url);
    }
  }, {
    key: "addRepoAPIToken",
    value: function addRepoAPIToken(repo_id, app_name, permission) {
      var url = this.server + '/api/v2.1/repos/' + repo_id + '/repo-api-tokens/';
      var form = new _formData["default"]();
      form.append('app_name', app_name);
      form.append('permission', permission);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "deleteRepoAPIToken",
    value: function deleteRepoAPIToken(repo_id, app_name) {
      var url = this.server + '/api/v2.1/repos/' + repo_id + '/repo-api-tokens/' + app_name + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "updateRepoAPIToken",
    value: function updateRepoAPIToken(repo_id, app_name, permission) {
      var url = this.server + '/api/v2.1/repos/' + repo_id + '/repo-api-tokens/' + app_name + '/';
      var form = new _formData["default"]();
      form.append('permission', permission);
      return this.req.put(url, form);
    } //admin

  }, {
    key: "listDeletedRepo",
    value: function listDeletedRepo() {
      var url = this.server + '/api/v2.1/deleted-repos/';
      return this.req.get(url);
    }
  }, {
    key: "restoreDeletedRepo",
    value: function restoreDeletedRepo(repoID) {
      var url = this.server + '/api/v2.1/deleted-repos/';
      var form = new _formData["default"]();
      form.append('repo_id', repoID);
      return this._sendPostRequest(url, form);
    } //---- directory operation

  }, {
    key: "listDir",
    value: function listDir(repoID, dirPath) {
      var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref3$recursive = _ref3.recursive,
          recursive = _ref3$recursive === void 0 ? false : _ref3$recursive,
          _ref3$type = _ref3.type,
          type = _ref3$type === void 0 ? '' : _ref3$type,
          _ref3$with_thumbnail = _ref3.with_thumbnail,
          with_thumbnail = _ref3$with_thumbnail === void 0 ? false : _ref3$with_thumbnail,
          _ref3$with_parents = _ref3.with_parents,
          with_parents = _ref3$with_parents === void 0 ? false : _ref3$with_parents;

      /*
       * opts: `{recursive: true}`, `{'with_thumbnail': true}`
       */
      var url = this.server + '/api/v2.1/repos/' + repoID + '/dir/';
      var params = {};
      params.p = dirPath;

      if (recursive) {
        params.recursive = recursive ? 1 : 0;
      }

      if (type) {
        params.t = type;
      }

      if (with_thumbnail) {
        params.with_thumbnail = with_thumbnail;
      }

      if (with_parents) {
        params.with_parents = with_parents;
      }

      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "listWikiDir",
    value: function listWikiDir(slug, dirPath, withParents) {
      var path = encodeURIComponent(dirPath);
      var url = this.server + '/api/v2.1/wikis/' + encodeURIComponent(slug) + '/dir/?p=' + path;

      if (withParents) {
        url = this.server + '/api/v2.1/wikis/' + encodeURIComponent(slug) + '/dir/?p=' + path + '&with_parents=' + withParents;
      }

      return this.req.get(url);
    }
  }, {
    key: "getDirInfo",
    value: function getDirInfo(repoID, dirPath) {
      var path = encodeURIComponent(dirPath);
      var url = this.server + '/api/v2.1/repos/' + repoID + '/dir/detail/?path=' + path;
      return this.req.get(url);
    }
  }, {
    key: "createDir",
    value: function createDir(repoID, dirPath) {
      var path = encodeURIComponent(dirPath);
      var url = this.server + '/api2/repos/' + repoID + '/dir/?p=' + path;
      var form = new _formData["default"]();
      form.append('operation', 'mkdir');
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "renameDir",
    value: function renameDir(repoID, dirPath, newdirName) {
      var path = encodeURIComponent(dirPath);
      var url = this.server + '/api2/repos/' + repoID + '/dir/?p=' + path;
      var form = new _formData["default"]();
      form.append("operation", 'rename');
      form.append("newname", newdirName);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "deleteDir",
    value: function deleteDir(repoID, dirPath) {
      var path = encodeURIComponent(dirPath);
      var url = this.server + '/api/v2.1/repos/' + repoID + '/dir/?p=' + path;
      return this.req["delete"](url);
    } //---- multiple(File&Folder) operation

  }, {
    key: "copyDir",
    value: function copyDir(repoID, dstrepoID, dstfilePath, dirPath, direntNames) {
      var paths = [];
      var url = this.server;
      url += repoID === dstrepoID ? '/api/v2.1/repos/sync-batch-copy-item/' : '/api/v2.1/repos/async-batch-copy-item/';

      if (Array.isArray(direntNames)) {
        paths = direntNames;
      } else {
        paths.push(direntNames);
      }

      var operation = {
        'src_repo_id': repoID,
        'src_parent_dir': dirPath,
        'dst_repo_id': dstrepoID,
        'dst_parent_dir': dstfilePath,
        'src_dirents': paths
      };
      return this._sendPostRequest(url, operation, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
  }, {
    key: "moveDir",
    value: function moveDir(repoID, dstrepoID, dstfilePath, dirPath, direntNames) {
      var paths = [];
      var url = this.server;
      url += repoID === dstrepoID ? '/api/v2.1/repos/sync-batch-move-item/' : '/api/v2.1/repos/async-batch-move-item/';

      if (Array.isArray(direntNames)) {
        paths = direntNames;
      } else {
        paths.push(direntNames);
      }

      var operation = {
        'src_repo_id': repoID,
        'src_parent_dir': dirPath,
        'dst_repo_id': dstrepoID,
        'dst_parent_dir': dstfilePath,
        'src_dirents': paths
      };
      return this._sendPostRequest(url, operation, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
  }, {
    key: "queryAsyncOperationProgress",
    value: function queryAsyncOperationProgress(task_id) {
      var url = this.server + '/api/v2.1/query-copy-move-progress/?task_id=' + task_id;
      return this.req.get(url);
    }
  }, {
    key: "cancelCopyMoveOperation",
    value: function cancelCopyMoveOperation(task_id) {
      var url = this.server + '/api/v2.1/copy-move-task/';
      var params = {
        task_id: task_id
      };
      return this.req["delete"](url, {
        data: params
      });
    }
  }, {
    key: "deleteMutipleDirents",
    value: function deleteMutipleDirents(repoID, parentDir, direntNames) {
      var url = this.server + '/api/v2.1/repos/batch-delete-item/';
      var operation = {
        'repo_id': repoID,
        'parent_dir': parentDir,
        'dirents': direntNames
      };
      return this.req["delete"](url, {
        data: operation
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
  }, {
    key: "zipDownload",
    value: function zipDownload(repoID, parent_dir, dirents) {
      // can download one dir
      var url = this.server + '/api/v2.1/repos/' + repoID + '/zip-task/';
      var form = new _formData["default"]();
      form.append('parent_dir', parent_dir);

      if (Array.isArray(dirents)) {
        dirents.forEach(function (item) {
          form.append('dirents', item);
        });
      } else {
        form.append('dirents', dirents);
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "queryZipProgress",
    value: function queryZipProgress(zip_token) {
      var url = this.server + '/api/v2.1/query-zip-progress/?token=' + zip_token;
      return this.req.get(url);
    }
  }, {
    key: "cancelZipTask",
    value: function cancelZipTask(zip_token) {
      var url = this.server + '/api/v2.1/cancel-zip-task/';
      var form = new _formData["default"]();
      form.append("token", zip_token);
      return this.req.post(url, form);
    } //---- File Operation

  }, {
    key: "getFileInfo",
    value: function getFileInfo(repoID, filePath) {
      var path = encodeURIComponent(filePath);
      var url = this.server + '/api2/repos/' + repoID + '/file/detail/?p=' + path;
      return this.req.get(url);
    }
  }, {
    key: "getFileHistory",
    value: function getFileHistory(repoID, folderPath) {
      var url = this.server + "/api2/repos/" + repoID + "/file/history/?p=" + encodeURIComponent(folderPath);
      return this.req.get(url);
    }
  }, {
    key: "getFileDownloadLink",
    value: function getFileDownloadLink(repoID, filePath) {
      // reuse default to 1 to eliminate cross domain request problem
      //   In browser, the browser will send an option request to server first, the access Token
      //   will become invalid if reuse=0
      var path = encodeURIComponent(filePath);
      var url = this.server + '/api2/repos/' + repoID + '/file/?p=' + path + '&reuse=1';
      return this.req.get(url);
    }
  }, {
    key: "getFileContent",
    value: function getFileContent(downloadLink) {
      return _axios["default"].create().get(downloadLink);
    }
  }, {
    key: "createFile",
    value: function createFile(repoID, filePath, isDraft) {
      var path = encodeURIComponent(filePath);
      var url = this.server + '/api/v2.1/repos/' + repoID + '/file/?p=' + path;
      var form = new _formData["default"]();
      form.append('operation', 'create');
      form.append('is_draft', isDraft);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "renameFile",
    value: function renameFile(repoID, filePath, newfileName) {
      var path = encodeURIComponent(filePath);
      var url = this.server + '/api/v2.1/repos/' + repoID + '/file/?p=' + path;
      var form = new _formData["default"]();
      form.append('operation', 'rename');
      form.append('newname', newfileName);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "lockfile",
    value: function lockfile(repoID, filePath) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/file/?p=' + encodeURIComponent(filePath);
      var form = new _formData["default"]();
      form.append('operation', 'lock');
      return this.req.put(url, form);
    }
  }, {
    key: "unlockfile",
    value: function unlockfile(repoID, filePath) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/file/?p=' + encodeURIComponent(filePath);
      var form = new _formData["default"]();
      form.append('operation', 'unlock');
      return this.req.put(url, form);
    } // move need to add
    // copy need to add

  }, {
    key: "revertFile",
    value: function revertFile(repoID, path, commitID) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/file/?p=' + encodeURIComponent(path);
      var form = new _formData["default"]();
      form.append("operation", 'revert');
      form.append("commit_id", commitID);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "revertFolder",
    value: function revertFolder(repoID, path, commitID) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/dir/?p=' + encodeURIComponent(path);
      var form = new _formData["default"]();
      form.append("operation", 'revert');
      form.append("commit_id", commitID);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "revertRepo",
    value: function revertRepo(repoID, commitID) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/commits/' + commitID + '/revert/';
      return this.req.post(url);
    }
  }, {
    key: "deleteFile",
    value: function deleteFile(repoID, filePath) {
      var path = encodeURIComponent(filePath);
      var url = this.server + '/api/v2.1/repos/' + repoID + '/file/?p=' + path;
      return this.req["delete"](url);
    }
  }, {
    key: "getFileServerUploadLink",
    value: function getFileServerUploadLink(repoID, folderPath) {
      var path = encodeURIComponent(folderPath);
      var url = this.server + '/api2/repos/' + repoID + '/upload-link/?p=' + path + '&from=web';
      return this.req.get(url);
    } // for shared folder link with 'can_upload' permission

  }, {
    key: "sharedLinkGetFileUploadUrl",
    value: function sharedLinkGetFileUploadUrl(token, path) {
      var url = this.server + '/api/v2.1/share-links/' + token + '/upload/?path=' + encodeURIComponent(path);
      return this.req.get(url);
    }
  }, {
    key: "getFileUploadedBytes",
    value: function getFileUploadedBytes(repoID, filePath, fileName) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/file-uploaded-bytes/';
      var params = {
        parent_dir: filePath,
        file_name: fileName
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sharedUploadLinkGetFileUploadUrl",
    value: function sharedUploadLinkGetFileUploadUrl(token) {
      var url = this.server + '/api/v2.1/upload-links/' + token + '/upload/';
      return this.req.get(url);
    }
  }, {
    key: "shareLinksUploadDone",
    value: function shareLinksUploadDone(token, filePath) {
      var url = this.server + '/api/v2.1/share-links/' + token + '/upload/done/';
      var form = new _formData["default"]();
      form.append('file_path', filePath);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "uploadImage",
    value: function uploadImage(uploadLink, formData) {
      var onUploadProgress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return _axios["default"].create()({
        method: "post",
        data: formData,
        url: uploadLink,
        onUploadProgress: onUploadProgress
      });
    }
  }, {
    key: "getUpdateLink",
    value: function getUpdateLink(repoID, folderPath) {
      var url = this.server + '/api2/repos/' + repoID + '/update-link/?p=' + encodeURIComponent(folderPath);
      return this.req.get(url);
    }
  }, {
    key: "updateFile",
    value: function updateFile(uploadLink, filePath, fileName, data) {
      var formData = new _formData["default"]();
      formData.append("target_file", filePath);
      formData.append("filename", fileName);
      var blob = new Blob([data], {
        type: "text/plain"
      });
      formData.append("file", blob);
      return _axios["default"].create()({
        method: 'post',
        url: uploadLink,
        data: formData
      });
    }
  }, {
    key: "listFileHistoryRecords",
    value: function listFileHistoryRecords(repoID, path, page, per_page) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/file/new_history/';
      var params = {
        path: path,
        page: page,
        per_page: per_page
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "listOldFileHistoryRecords",
    value: function listOldFileHistoryRecords(repoID, path, commitID) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/file/history/';
      var params = {
        path: path,
        commit_id: commitID
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "getFileRevision",
    value: function getFileRevision(repoID, commitID, filePath) {
      var url = this.server + '/api2/' + 'repos/' + repoID + '/file' + '/revision/?p=' + encodeURIComponent(filePath) + '&commit_id=' + commitID;
      return this.req.get(url);
    } // file commit api

  }, {
    key: "deleteComment",
    value: function deleteComment(repoID, commentID) {
      var url = this.server + '/api2/repos/' + repoID + '/file/comments/' + commentID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "listComments",
    value: function listComments(repoID, filePath, resolved) {
      var path = encodeURIComponent(filePath);
      var url = this.server + '/api2/repos/' + repoID + '/file/comments/?p=' + path;

      if (resolved) {
        url = url + '&resolved=' + resolved;
      }

      return this.req.get(url);
    }
  }, {
    key: "postComment",
    value: function postComment(repoID, filePath, comment, detail) {
      var path = encodeURIComponent(filePath);
      var url = this.server + '/api2/repos/' + repoID + '/file/comments/?p=' + path;
      var form = new _formData["default"]();
      form.append("comment", comment);

      if (detail) {
        form.append("detail", detail);
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "getCommentsNumber",
    value: function getCommentsNumber(repoID, path) {
      var p = encodeURIComponent(path);
      var url = this.server + '/api2/repos/' + repoID + '/file/comments/counts/?p=' + p;
      return this.req.get(url);
    }
  }, {
    key: "updateComment",
    value: function updateComment(repoID, commentID, resolved, detail, comment) {
      var url = this.server + '/api2/repos/' + repoID + '/file/comments/' + commentID + '/';
      var params = {};
      if (resolved) params.resolved = resolved;
      if (detail) params.detail = detail;
      if (comment) params.comment = comment;
      return this.req.put(url, params);
    }
  }, {
    key: "getRepoDraftCounts",
    value: function getRepoDraftCounts(repoID) {
      var url = this.server + '/api/v2.1/repo/' + repoID + '/draft-counts/';
      return this.req.get(url);
    }
  }, {
    key: "listRepoDrafts",
    value: function listRepoDrafts(repoID) {
      var url = this.server + '/api/v2.1/repo/' + repoID + '/drafts/';
      return this.req.get(url);
    } // draft operation api

  }, {
    key: "getDraft",
    value: function getDraft(id) {
      var url = this.server + '/api/v2.1/drafts/' + id + '/';
      return this.req.get(url);
    }
  }, {
    key: "listDrafts",
    value: function listDrafts() {
      var url = this.server + '/api/v2.1/drafts';
      return this.req.get(url);
    }
  }, {
    key: "createDraft",
    value: function createDraft(repoID, filePath) {
      var url = this.server + '/api/v2.1/drafts/';
      var form = new _formData["default"]();
      form.append("repo_id", repoID);
      form.append("file_path", filePath);
      return this.req.post(url, form);
    }
  }, {
    key: "deleteDraft",
    value: function deleteDraft(id) {
      var url = this.server + '/api/v2.1/drafts/' + id + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "publishDraft",
    value: function publishDraft(id) {
      var url = this.server + '/api/v2.1/drafts/' + id + '/';
      var params = {
        operation: 'publish'
      };
      return this.req.put(url, params);
    } // review api

  }, {
    key: "listDraftReviewers",
    value: function listDraftReviewers(draftID) {
      var url = this.server + '/api/v2.1/drafts/' + draftID + '/reviewer/';
      return this.req.get(url);
    }
  }, {
    key: "addDraftReviewers",
    value: function addDraftReviewers(draftID, reviewers) {
      var url = this.server + '/api/v2.1/drafts/' + draftID + '/reviewer/';
      var form = new _formData["default"]();

      for (var i = 0; i < reviewers.length; i++) {
        form.append('reviewer', reviewers[i]);
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "deleteDraftReviewer",
    value: function deleteDraftReviewer(draftID, reviewer) {
      var url = this.server + '/api/v2.1/drafts/' + draftID + '/reviewer/?username=' + encodeURIComponent(reviewer);
      return this.req["delete"](url);
    } // starred

  }, {
    key: "listStarredItems",
    value: function listStarredItems() {
      var url = this.server + '/api/v2.1/starred-items/';
      return this.req.get(url);
    }
  }, {
    key: "starItem",
    value: function starItem(repoID, path) {
      var url = this.server + '/api/v2.1/starred-items/';
      var form = new _formData["default"]();
      form.append('repo_id', repoID);
      form.append('path', path);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "unstarItem",
    value: function unstarItem(repoID, path) {
      var url = this.server + '/api/v2.1/starred-items/?repo_id=' + repoID + '&path=' + encodeURIComponent(path);
      return this.req["delete"](url);
    }
  }, {
    key: "monitorRepo",
    value: function monitorRepo(repoID) {
      var url = this.server + '/api/v2.1/monitored-repos/';
      var form = new _formData["default"]();
      form.append('repo_id', repoID);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "unMonitorRepo",
    value: function unMonitorRepo(repoID) {
      var url = this.server + '/api/v2.1/monitored-repos/' + repoID + '/';
      return this.req["delete"](url);
    } //---- tags module api
    // repo tags

  }, {
    key: "listRepoTags",
    value: function listRepoTags(repoID) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/repo-tags/';
      return this.req.get(url);
    }
  }, {
    key: "createRepoTag",
    value: function createRepoTag(repoID, name, color) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/repo-tags/';
      var form = new _formData["default"]();
      form.append('name', name);
      form.append('color', color);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "deleteRepoTag",
    value: function deleteRepoTag(repoID, repo_tag_id) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/repo-tags/' + repo_tag_id + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "updateRepoTag",
    value: function updateRepoTag(repoID, repo_tag_id, name, color) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/repo-tags/' + repo_tag_id + '/';
      var params = {
        name: name,
        color: color
      };
      return this.req.put(url, params);
    }
  }, {
    key: "listTaggedFiles",
    value: function listTaggedFiles(repoID, repoTagId) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/tagged-files/' + repoTagId + '/';
      return this.req.get(url);
    } // file tag api

  }, {
    key: "listFileTags",
    value: function listFileTags(repoID, filePath) {
      var p = encodeURIComponent(filePath);
      var url = this.server + '/api/v2.1/repos/' + repoID + '/file-tags/?file_path=' + p;
      return this.req.get(url);
    }
  }, {
    key: "addFileTag",
    value: function addFileTag(repoID, filePath, repoTagId) {
      var form = new _formData["default"]();
      form.append('file_path', filePath);
      form.append('repo_tag_id', repoTagId);
      var url = this.server + '/api/v2.1/repos/' + repoID + '/file-tags/';
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "deleteFileTag",
    value: function deleteFileTag(repoID, fileTagId) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/file-tags/' + fileTagId + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "saveSharedFile",
    value: function saveSharedFile(repoID, dstPath, sharedToken, filePath) {
      var url = this.server + '/api/v2.1/share-links/' + sharedToken + '/save-file-to-repo/';
      var form = new _formData["default"]();
      form.append('dst_repo_id', repoID);
      form.append('dst_parent_dir', dstPath); // for file in shared dir

      if (filePath) {
        form.append('path', filePath);
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "saveSharedDir",
    value: function saveSharedDir(repoID, dstPath, sharedToken, parentDir, items) {
      var url = this.server + '/api/v2.1/share-links/' + sharedToken + '/save-items-to-repo/';
      var form = new _formData["default"]();
      form.append('src_parent_dir', parentDir);
      items.forEach(function (item) {
        form.append('src_dirents', item);
      });
      form.append('dst_repo_id', repoID);
      form.append('dst_parent_dir', dstPath);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "addAbuseReport",
    value: function addAbuseReport(sharedToken, abuseType, description, reporter, filePath) {
      var url = this.server + '/api/v2.1/abuse-reports/';
      var form = new _formData["default"]();
      form.append('share_link_token', sharedToken);
      form.append('abuse_type', abuseType);
      form.append('description', description);
      form.append('reporter', reporter);
      form.append('file_path', filePath);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "sysAdminListAbuseReports",
    value: function sysAdminListAbuseReports() {
      var url = this.server + '/api/v2.1/admin/abuse-reports/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminUpdateAbuseReport",
    value: function sysAdminUpdateAbuseReport(handled, abuseReportId) {
      var url = this.server + '/api/v2.1/admin/abuse-reports/' + abuseReportId + '/';
      var form = new _formData["default"]();
      form.append('handled', handled);
      return this.req.put(url, form);
    }
  }, {
    key: "getInternalLink",
    value: function getInternalLink(repoID, filePath, direntType) {
      var isDir = direntType === 'dir' ? true : false;
      var path = encodeURIComponent(filePath);
      var url = this.server + '/api/v2.1/smart-link/?repo_id=' + repoID + '&path=' + path + '&is_dir=' + isDir;
      return this.req.get(url);
    }
  }, {
    key: "getWikiFileContent",
    value: function getWikiFileContent(slug, filePath) {
      var path = encodeURIComponent(filePath);
      var time = new Date().getTime();
      var url = this.server + '/api/v2.1/wikis/' + encodeURIComponent(slug) + '/content/' + '?p=' + path + '&_=' + time;
      return this.req.get(url);
    } //---- Avatar API

  }, {
    key: "getUserAvatar",
    value: function getUserAvatar(user, size) {
      var url = this.server + '/api2/avatars/user/' + encodeURIComponent(user) + '/resized/' + size + '/';
      return this.req.get(url);
    } //---- Notification API

  }, {
    key: "listNotifications",
    value: function listNotifications(page, perPage) {
      var url = this.server + '/api/v2.1/notifications/';
      var params = {
        page: page,
        per_page: perPage
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "updateNotifications",
    value: function updateNotifications() {
      var url = this.server + '/api/v2.1/notifications/';
      return this.req.put(url);
    }
  }, {
    key: "deleteNotifications",
    value: function deleteNotifications() {
      var url = this.server + '/api/v2.1/notifications/';
      return this.req["delete"](url);
    }
  }, {
    key: "getUnseenNotificationCount",
    value: function getUnseenNotificationCount() {
      var url = this.server + '/api/v2.1/notifications/';
      return this.req.get(url);
    }
  }, {
    key: "markNoticeAsRead",
    value: function markNoticeAsRead(noticeId) {
      var url = this.server + '/api/v2.1/notification/';
      var from = new _formData["default"]();
      from.append('notice_id', noticeId);
      return this.req.put(url, from);
    } //---- Linked Devices API

  }, {
    key: "listLinkedDevices",
    value: function listLinkedDevices() {
      var url = this.server + '/api2/devices/';
      return this.req.get(url);
    }
  }, {
    key: "unlinkDevice",
    value: function unlinkDevice(platform, deviceID, wipeDevice) {
      var url = this.server + "/api2/devices/";
      var param = {
        platform: platform,
        device_id: deviceID,
        wipe_device: wipeDevice ? 'true' : 'false'
      };
      return this.req["delete"](url, {
        data: param
      });
    } //---- Activities API

  }, {
    key: "listActivities",
    value: function listActivities(pageNum) {
      var avatarSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 36;
      var url = this.server + '/api/v2.1/activities/?page=' + pageNum + '&avatar_size=' + avatarSize;
      return this.req.get(url);
    } //---- Thumbnail API

  }, {
    key: "createThumbnail",
    value: function createThumbnail(repo_id, path, thumbnail_size) {
      var url = this.server + '/thumbnail/' + repo_id + '/create/?path=' + encodeURIComponent(path) + '&size=' + thumbnail_size;
      return this.req.get(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
    } //---- Users API

  }, {
    key: "searchUsers",
    value: function searchUsers(searchParam) {
      var url = this.server + '/api2/search-user/?q=' + encodeURIComponent(searchParam);
      return this.req.get(url);
    } //---- wiki module API

  }, {
    key: "listWikis",
    value: function listWikis(options) {
      /*
       * options: `{type: 'shared'}`, `{type: ['mine', 'shared', ...]}`
       */
      var url = this.server + '/api/v2.1/wikis/';

      if (!options) {
        // fetch all types of wikis
        return this.req.get(url);
      }

      return this.req.get(url, {
        params: options,
        paramsSerializer: {
          serialize: function serialize(params) {
            var list = [];

            for (var key in params) {
              if (Array.isArray(params[key])) {
                for (var i = 0, len = params[key].length; i < len; i++) {
                  list.push(key + '=' + encodeURIComponent(params[key][i]));
                }
              } else {
                list.push(key + '=' + encodeURIComponent(params[key]));
              }
            }

            return list.join('&');
          }
        }
      });
    }
  }, {
    key: "addWiki",
    value: function addWiki(repoID) {
      var url = this.server + '/api/v2.1/wikis/';
      var form = new _formData["default"]();
      form.append('repo_id', repoID);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "renameWiki",
    value: function renameWiki(slug, name) {
      var url = this.server + '/api/v2.1/wikis/' + slug + '/';
      var form = new _formData["default"]();
      form.append('wiki_name', name);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "updateWikiPermission",
    value: function updateWikiPermission(wikiSlug, permission) {
      var url = this.server + '/api/v2.1/wikis/' + wikiSlug + '/';
      var params = {
        permission: permission
      };
      return this.req.put(url, params);
    }
  }, {
    key: "deleteWiki",
    value: function deleteWiki(slug) {
      var url = this.server + '/api/v2.1/wikis/' + slug + '/';
      return this.req["delete"](url);
    } //----MetaData API

  }, {
    key: "fileMetaData",
    value: function fileMetaData(repoID, filePath) {
      var url = this.server + '/api2/repos/' + repoID + '/file/metadata/?p=' + encodeURIComponent(filePath);
      return this.req.get(url);
    }
  }, {
    key: "dirMetaData",
    value: function dirMetaData(repoID, dirPath) {
      var url = this.server + '/api2/repos/' + repoID + '/dir/metadata/?p=' + encodeURIComponent(dirPath);
      return this.req.get(url);
    } // single org admin api

  }, {
    key: "orgAdminGetOrgInfo",
    value: function orgAdminGetOrgInfo() {
      var url = this.server + '/api/v2.1/org/admin/info/';
      return this.req.get(url);
    }
  }, {
    key: "orgAdminGetSysSettingInfo",
    value: function orgAdminGetSysSettingInfo(orgID) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/web-settings/';
      return this.req.get(url);
    }
  }, {
    key: "orgAdminSetSysSettingInfo",
    value: function orgAdminSetSysSettingInfo(orgID, key, value) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/web-settings/';
      var formData = new _formData["default"]();
      formData.append(key, value);
      return this.req.put(url, formData);
    }
  }, {
    key: "orgAdminUpdateName",
    value: function orgAdminUpdateName(orgID, orgName) {
      var url = this.server + '/api/v2.1/org/admin/info/';
      var form = new _formData["default"]();
      form.append('org_name', orgName);
      return this.req.put(url, form);
    }
  }, {
    key: "orgAdminUpdateLogo",
    value: function orgAdminUpdateLogo(orgID, file) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/logo/';
      var form = new _formData["default"]();
      form.append('file', file);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "orgAdminUploadIdpCertificate",
    value: function orgAdminUploadIdpCertificate(orgID, file) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/saml-idp-certificate/';
      var formData = new _formData["default"]();
      formData.append('idp_certificate', file);
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "orgAdminGetSamlConfig",
    value: function orgAdminGetSamlConfig(orgID) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/saml-config/';
      return this.req.get(url);
    }
  }, {
    key: "orgAdminAddSamlConfig",
    value: function orgAdminAddSamlConfig(orgID, metadataUrl) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/saml-config/';
      var data = {
        metadata_url: metadataUrl
      };
      return this.req.post(url, data);
    }
  }, {
    key: "orgAdminUpdateSamlConfig",
    value: function orgAdminUpdateSamlConfig(orgID, metadataUrl) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/saml-config/';
      var data = {
        metadata_url: metadataUrl
      };
      return this.req.put(url, data);
    }
  }, {
    key: "orgAdminDeleteSamlConfig",
    value: function orgAdminDeleteSamlConfig(orgID) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/saml-config/';
      return this.req["delete"](url);
    }
  }, {
    key: "orgAdminGetUrlPrefix",
    value: function orgAdminGetUrlPrefix(orgID) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/url-prefix/';
      return this.req.get(url);
    }
  }, {
    key: "orgAdminUpdateUrlPrefix",
    value: function orgAdminUpdateUrlPrefix(orgID, orgUrlPrefix) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/url-prefix/';
      var data = {
        org_url_prefix: orgUrlPrefix
      };
      return this.req.put(url, data);
    }
  }, {
    key: "orgAdminStatisticFiles",
    value: function orgAdminStatisticFiles(orgID, startTime, endTime, groupBy) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/statistics/file-operations/';
      var params = {
        start: startTime,
        end: endTime,
        group_by: groupBy
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "orgAdminStatisticStorages",
    value: function orgAdminStatisticStorages(orgID, startTime, endTime, groupBy) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/statistics/total-storage/';
      var params = {
        start: startTime,
        end: endTime,
        group_by: groupBy
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "orgAdminStatisticActiveUsers",
    value: function orgAdminStatisticActiveUsers(orgID, startTime, endTime, groupBy) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/statistics/active-users/';
      var params = {
        start: startTime,
        end: endTime,
        group_by: groupBy
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "orgAdminStatisticSystemTraffic",
    value: function orgAdminStatisticSystemTraffic(orgID, startTime, endTime, groupBy) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/statistics/system-traffic/';
      var params = {
        start: startTime,
        end: endTime,
        group_by: groupBy
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "orgAdminListUserTraffic",
    value: function orgAdminListUserTraffic(orgID, month, page, perPage, orderBy) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/statistics/user-traffic/';
      var params = {
        month: month,
        page: page,
        per_page: perPage,
        order_by: orderBy
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "orgAdminListDevices",
    value: function orgAdminListDevices(orgID, platform, page, per_page) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/devices/';
      var params = {
        platform: platform,
        page: page,
        per_page: per_page
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "orgAdminUnlinkDevice",
    value: function orgAdminUnlinkDevice(orgID, platform, deviceID, user, wipeDevice) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/devices/';
      var params = {
        wipe_device: wipeDevice ? 'true' : 'false',
        platform: platform,
        device_id: deviceID,
        user: user
      };
      return this.req["delete"](url, {
        data: params
      });
    }
  }, {
    key: "orgAdminListDevicesErrors",
    value: function orgAdminListDevicesErrors(orgID, page, per_page) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/devices-errors/';
      var params = {
        page: page,
        per_page: per_page
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "orgAdminListOrgUsers",
    value: function orgAdminListOrgUsers(orgID, isStaff, page, sortBy, sortOrder) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/users/';
      var params = {
        is_staff: isStaff,
        page: page
      };

      if (sortBy) {
        params.order_by = sortBy;
        params.direction = sortOrder;
      }

      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "orgAdminSearchUser",
    value: function orgAdminSearchUser(orgID, query) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/search-user/';
      var params = {
        query: query
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "orgAdminGetOrgUserBesharedRepos",
    value: function orgAdminGetOrgUserBesharedRepos(orgID, email) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/users/' + encodeURIComponent(email) + '/beshared-repos/';
      return this.req.get(url);
    }
  }, {
    key: "orgAdminGetOrgUserOwnedRepos",
    value: function orgAdminGetOrgUserOwnedRepos(orgID, email) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/users/' + encodeURIComponent(email) + '/repos/';
      return this.req.get(url);
    }
  }, {
    key: "orgAdminGetOrgUserInfo",
    value: function orgAdminGetOrgUserInfo(orgID, email) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/users/' + encodeURIComponent(email) + '/';
      return this.req.get(url);
    }
  }, {
    key: "orgAdminSetOrgUserName",
    value: function orgAdminSetOrgUserName(orgID, email, name) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/users/' + encodeURIComponent(email) + '/';
      var data = {
        name: name
      };
      return this.req.put(url, data);
    }
  }, {
    key: "orgAdminSetOrgUserContactEmail",
    value: function orgAdminSetOrgUserContactEmail(orgID, email, contactEmail) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/users/' + encodeURIComponent(email) + '/';
      var data = {
        contact_email: contactEmail
      };
      return this.req.put(url, data);
    }
  }, {
    key: "orgAdminSetOrgUserQuota",
    value: function orgAdminSetOrgUserQuota(orgID, email, quota) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/users/' + encodeURIComponent(email) + '/';
      var data = {
        quota_total: quota
      };
      return this.req.put(url, data);
    }
  }, {
    key: "orgAdminDeleteOrgUser",
    value: function orgAdminDeleteOrgUser(orgID, email) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/users/' + encodeURIComponent(email) + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "orgAdminResetOrgUserPassword",
    value: function orgAdminResetOrgUserPassword(orgID, email) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/users/' + encodeURIComponent(email) + '/set-password/';
      return this.req.put(url);
    }
  }, {
    key: "orgAdminChangeOrgUserStatus",
    value: function orgAdminChangeOrgUserStatus(orgID, email, isActive) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/users/' + encodeURIComponent(email) + '/';
      var form = new _formData["default"]();
      form.append('is_active', isActive);
      return this.req.put(url, form);
    }
  }, {
    key: "orgAdminAddOrgUser",
    value: function orgAdminAddOrgUser(orgID, email, name, password) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/users/';
      var form = new _formData["default"]();
      form.append('email', email);
      form.append('name', name);
      form.append('password', password);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "orgAdminImportUsersViaFile",
    value: function orgAdminImportUsersViaFile(orgID, file) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/import-users/';
      var formData = new _formData["default"]();
      formData.append('file', file);
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "orgAdminSetOrgAdmin",
    value: function orgAdminSetOrgAdmin(orgID, email, isStaff) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/users/' + encodeURIComponent(email) + '/';
      var form = new _formData["default"]();
      form.append('is_staff', isStaff);
      return this.req.put(url, form);
    }
  }, {
    key: "orgAdminListOrgGroups",
    value: function orgAdminListOrgGroups(orgID, page) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/groups/?page=' + page;
      return this.req.get(url);
    }
  }, {
    key: "orgAdminSearchGroup",
    value: function orgAdminSearchGroup(orgID, query) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/search-group/';
      var params = {
        query: query
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "orgAdminGetGroup",
    value: function orgAdminGetGroup(orgID, groupID) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/groups/' + groupID + '/';
      return this.req.get(url);
    }
  }, {
    key: "orgAdminDeleteOrgGroup",
    value: function orgAdminDeleteOrgGroup(orgID, groupID) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/groups/' + groupID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "orgAdminListOrgRepos",
    value: function orgAdminListOrgRepos(orgID, page, orderBy) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/repos/';
      var params = {
        page: page
      };

      if (orderBy) {
        params.order_by = orderBy;
      }

      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "orgAdminDeleteOrgRepo",
    value: function orgAdminDeleteOrgRepo(orgID, repoID) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/repos/' + repoID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "orgAdminTransferOrgRepo",
    value: function orgAdminTransferOrgRepo(orgID, repoID, email) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/repos/' + repoID + '/';
      var form = new _formData["default"]();
      form.append('email', email);
      return this.req.put(url, form);
    } // org links

  }, {
    key: "orgAdminListOrgLinks",
    value: function orgAdminListOrgLinks(page) {
      var url = this.server + '/api/v2.1/org/admin/links/?page=' + page;
      return this.req.get(url);
    }
  }, {
    key: "orgAdminDeleteOrgLink",
    value: function orgAdminDeleteOrgLink(token) {
      var url = this.server + '/api/v2.1/org/admin/links/' + token + '/';
      return this.req["delete"](url);
    } // org depart group

  }, {
    key: "orgAdminListDepartGroups",
    value: function orgAdminListDepartGroups(orgID) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/address-book/groups/';
      return this.req.get(url);
    }
  }, {
    key: "orgAdminListGroupInfo",
    value: function orgAdminListGroupInfo(orgID, groupID, showAncestors) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/address-book/groups/' + groupID + '/?return_ancestors=' + showAncestors;
      return this.req.get(url);
    }
  }, {
    key: "orgAdminAddDepartGroup",
    value: function orgAdminAddDepartGroup(orgID, parentGroup, groupName, groupOwner, groupStaff) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/address-book/groups/';
      var form = new _formData["default"]();
      form.append('parent_group', parentGroup);
      form.append('group_name', groupName);

      if (groupOwner) {
        form.append('group_owner', groupOwner);
      }

      if (groupStaff) {
        form.append('group_staff', groupStaff.join(','));
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "orgAdminUpdateDepartGroup",
    value: function orgAdminUpdateDepartGroup(orgID, groupID, groupName) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/address-book/groups/' + groupID + '/';
      var form = new _formData["default"]();
      form.append('group_name', groupName);
      return this.req.put(url, form);
    }
  }, {
    key: "orgAdminDeleteDepartGroup",
    value: function orgAdminDeleteDepartGroup(orgID, groupID) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/address-book/groups/' + groupID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "orgAdminSetGroupQuota",
    value: function orgAdminSetGroupQuota(orgID, groupID, quota) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/groups/' + groupID + '/';
      var form = new _formData["default"]();
      form.append('quota', quota);
      return this.req.put(url, form);
    }
  }, {
    key: "orgAdminListGroupRepos",
    value: function orgAdminListGroupRepos(orgID, groupID) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/groups/' + groupID + '/libraries/';
      return this.req.get(url);
    }
  }, {
    key: "orgAdminAddDepartmentRepo",
    value: function orgAdminAddDepartmentRepo(orgID, groupID, repoName) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/groups/' + groupID + '/group-owned-libraries/';
      var form = new _formData["default"]();
      form.append('repo_name', repoName);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "orgAdminDeleteDepartmentRepo",
    value: function orgAdminDeleteDepartmentRepo(orgID, groupID, repoID) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/groups/' + groupID + '/group-owned-libraries/' + repoID;
      return this.req["delete"](url);
    }
  }, {
    key: "orgAdminListGroupMembers",
    value: function orgAdminListGroupMembers(orgID, groupID) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/groups/' + groupID + '/members/';
      return this.req.get(url);
    }
  }, {
    key: "orgAdminDeleteGroupMember",
    value: function orgAdminDeleteGroupMember(orgID, groupID, userEmail) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/groups/' + groupID + '/members/' + encodeURIComponent(userEmail) + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "orgAdminAddGroupMember",
    value: function orgAdminAddGroupMember(orgID, groupID, userEmail) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/groups/' + groupID + '/members/';
      var form = new _formData["default"]();
      form.append('email', userEmail);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "orgAdminSetGroupMemberRole",
    value: function orgAdminSetGroupMemberRole(orgID, groupID, userEmail, isAdmin) {
      var url = this.server + '/api/v2.1/org/' + orgID + '/admin/groups/' + groupID + '/members/' + encodeURIComponent(userEmail) + '/';
      var form = new _formData["default"]();
      form.append('is_admin', isAdmin);
      return this.req.put(url, form);
    } // org admin logs

  }, {
    key: "orgAdminListFileAudit",
    value: function orgAdminListFileAudit(email, repoID, page) {
      var url = this.server + '/api/v2.1/org/admin/logs/file-access/?page=' + page;

      if (email) {
        url = url + '&email=' + encodeURIComponent(email);
      }

      if (repoID) {
        url = url + '&repo_id=' + repoID;
      }

      return this.req.get(url);
    }
  }, {
    key: "orgAdminListFileUpdate",
    value: function orgAdminListFileUpdate(email, repoID, page) {
      var url = this.server + '/api/v2.1/org/admin/logs/file-update/?page=' + page;

      if (email) {
        url = url + '&email=' + encodeURIComponent(email);
      }

      if (repoID) {
        url = url + '&repo_id=' + repoID;
      }

      return this.req.get(url);
    }
  }, {
    key: "orgAdminListPermAudit",
    value: function orgAdminListPermAudit(email, repoID, page) {
      var url = this.server + '/api/v2.1/org/admin/logs/repo-permission/?page=' + page;

      if (email) {
        url = url + '&email=' + encodeURIComponent(email);
      }

      if (repoID) {
        url = url + '&repo_id=' + repoID;
      }

      return this.req.get(url);
    }
  }, {
    key: "orgAdminGetFileUpdateDetail",
    value: function orgAdminGetFileUpdateDetail(repoID, commitID) {
      var url = this.server + '/ajax/repo/' + repoID + '/history/changes/?commit_id=' + commitID;
      return this.req.get(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
    }
  }, {
    key: "markdownLint",
    value: function markdownLint(slateValue) {
      var url = this.server + '/api/v2.1/markdown-lint/';
      var form = new _formData["default"]();
      form.append('slate', slateValue);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "listFileScanRecords",
    value: function listFileScanRecords() {
      var url = this.server + '/api/v2.1/admin/file-scan-records/';
      return this.req.get(url);
    }
  }, {
    key: "queryOfficeFileConvertStatus",
    value: function queryOfficeFileConvertStatus(repoID, commitID, path, fileType, shareToken) {
      var url = this.server + '/office-convert/status/';
      var params = {
        repo_id: repoID,
        commit_id: commitID,
        path: path,
        doctype: fileType // 'document' or 'spreadsheet'

      }; // for view of share link

      if (shareToken) {
        params['token'] = shareToken;
      }

      return this.req.get(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        params: params
      });
    }
  }, {
    key: "listSharedDir",
    value: function listSharedDir(token, path, thumbnailSize) {
      var url = this.server + '/api/v2.1/share-links/' + token + '/dirents/';
      var params = {
        thumbnail_size: thumbnailSize,
        path: path
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "getShareLinkZipTask",
    value: function getShareLinkZipTask(token, path) {
      var url = this.server + '/api/v2.1/share-link-zip-task/';
      var params = {
        share_link_token: token,
        path: path
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "getShareLinkDirentsZipTask",
    value: function getShareLinkDirentsZipTask(token, path, dirents) {
      var url = this.server + '/api/v2.1/share-link-zip-task/';
      var params = {
        token: token,
        parent_dir: path,
        dirents: dirents
      };
      return this.req.post(url, params);
    }
  }, {
    key: "getShareLinkThumbnail",
    value: function getShareLinkThumbnail(token, filePath, thumbnailSize) {
      var url = this.server + '/thumbnail/' + token + '/create/';
      var params = {
        path: filePath,
        size: thumbnailSize
      };
      return this.req.get(url, {
        params: params
      });
    } // get all existing repo snapshot labels of the user

  }, {
    key: "getAllRepoSnapshotLabels",
    value: function getAllRepoSnapshotLabels() {
      var url = this.server + '/api/v2.1/revision-tags/tag-names/';
      return this.req.get(url);
    }
  }, {
    key: "addNewRepoLabels",
    value: function addNewRepoLabels(repoID, labels) {
      var url = this.server + '/api/v2.1/revision-tags/tagged-items/';
      var data = {
        'repo_id': repoID,
        'tag_names': labels
      };
      return this.req.post(url, data);
    }
  }, {
    key: "updateRepoCommitLabels",
    value: function updateRepoCommitLabels(repoID, commitID, labels) {
      var url = this.server + '/api/v2.1/revision-tags/tagged-items/';
      var data = {
        'repo_id': repoID,
        'commit_id': commitID,
        'tag_names': labels
      };
      return this.req.put(url, data);
    }
  }, {
    key: "invitePeople",
    value: function invitePeople(emails) {
      var url = this.server + '/api/v2.1/invitations/batch/';
      var form = new _formData["default"]();
      form.append('type', 'guest');

      for (var i = 0; i < emails.length; i++) {
        form.append('accepter', emails[i]);
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "listInvitations",
    value: function listInvitations() {
      var url = this.server + '/api/v2.1/invitations/';
      return this.req.get(url);
    }
  }, {
    key: "deleteInvitation",
    value: function deleteInvitation(token) {
      var url = this.server + '/api/v2.1/invitations/' + token + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "revokeInvitation",
    value: function revokeInvitation(token) {
      var url = this.server + '/api/v2.1/invitations/' + token + '/revoke/';
      return this.req.post(url);
    }
  }, {
    key: "addRepoShareInvitations",
    value: function addRepoShareInvitations(repoID, path, emails, permission) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/shared/invitations/batch/';
      var data = {
        type: 'guest',
        accepters: emails,
        path: path,
        permission: permission
      };
      return this.req.post(url, data);
    }
  }, {
    key: "listRepoShareInvitations",
    value: function listRepoShareInvitations(repoID, path) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/shared/invitations/?path=' + path;
      return this.req.get(url);
    }
  }, {
    key: "updateRepoShareInvitation",
    value: function updateRepoShareInvitation(repoID, path, token, permission) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/shared/invitation/';
      var data = {
        token: token,
        path: path,
        permission: permission
      };
      return this.req.put(url, data);
    }
  }, {
    key: "deleteRepoShareInvitation",
    value: function deleteRepoShareInvitation(repoID, path, token) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/shared/invitation/';
      var params = {
        token: token,
        path: path
      };
      return this.req["delete"](url, {
        data: params
      });
    }
  }, {
    key: "updateUserAvatar",
    value: function updateUserAvatar(avatarFile, avatarSize) {
      var url = this.server + '/api/v2.1/user-avatar/';
      var form = new _formData["default"]();
      form.append('avatar', avatarFile);
      form.append('avatar_size', avatarSize);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      var url = this.server + '/api/v2.1/user/';
      return this.req.get(url);
    }
  }, {
    key: "updateUserInfo",
    value: function updateUserInfo(_ref4) {
      var name = _ref4.name,
          telephone = _ref4.telephone,
          contact_email = _ref4.contact_email,
          list_in_address_book = _ref4.list_in_address_book;
      var url = this.server + '/api/v2.1/user/';
      var data = {};

      if (name != undefined) {
        data.name = name;
      }

      if (telephone != undefined) {
        data.telephone = telephone;
      }

      if (contact_email != undefined) {
        data.contact_email = contact_email;
      }

      if (list_in_address_book != undefined) {
        data.list_in_address_book = list_in_address_book;
      }

      return this.req.put(url, data);
    }
  }, {
    key: "updateEmailNotificationInterval",
    value: function updateEmailNotificationInterval(fileUpdatesEmailInterval, collaborateEmailInterval) {
      var url = this.server + '/api2/account/info/';
      var data = {
        'file_updates_email_interval': fileUpdatesEmailInterval,
        'collaborate_email_interval': collaborateEmailInterval
      };
      return this.req.put(url, data);
    }
  }, {
    key: "updateWebdavSecret",
    value: function updateWebdavSecret(password) {
      var url = this.server + '/api/v2.1/webdav-secret/';
      var data = {
        'secret': password
      };
      return this.req.put(url, data);
    }
  }, {
    key: "listUserFolderPerm",
    value: function listUserFolderPerm(repoID, folderPath) {
      var url = this.server + '/api2/repos/' + repoID + '/user-folder-perm/';

      if (folderPath) {
        url = url + '?folder_path=' + encodeURIComponent(folderPath);
      }

      return this.req.get(url);
    }
  }, {
    key: "addUserFolderPerm",
    value: function addUserFolderPerm(repoID, permission, folderPath, userEmail) {
      var url = this.server + '/api2/repos/' + repoID + '/user-folder-perm/';
      var form = new _formData["default"]();
      form.append('permission', permission);
      form.append('folder_path', folderPath);

      if (Array.isArray(userEmail)) {
        userEmail.forEach(function (item) {
          form.append('user_email', item);
        });
      } else {
        form.append('user_email', userEmail);
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "updateUserFolderPerm",
    value: function updateUserFolderPerm(repoID, permission, folderPath, userEmail) {
      var url = this.server + '/api2/repos/' + repoID + '/user-folder-perm/';
      var form = new _formData["default"]();
      form.append('permission', permission);
      form.append('folder_path', folderPath);
      form.append('user_email', userEmail);
      return this.req.put(url, form);
    }
  }, {
    key: "deleteUserFolderPerm",
    value: function deleteUserFolderPerm(repoID, permission, folderPath, userEmail) {
      var url = this.server + '/api2/repos/' + repoID + '/user-folder-perm/';
      var param = {
        permission: permission,
        folder_path: folderPath,
        user_email: userEmail
      };
      return this.req["delete"](url, {
        data: param
      });
    }
  }, {
    key: "listGroupFolderPerm",
    value: function listGroupFolderPerm(repoID, folderPath) {
      var url = this.server + '/api2/repos/' + repoID + '/group-folder-perm/';

      if (folderPath) {
        url = url + '?folder_path=' + encodeURIComponent(folderPath);
      }

      return this.req.get(url);
    }
  }, {
    key: "addGroupFolderPerm",
    value: function addGroupFolderPerm(repoID, permission, folderPath, groupID) {
      var url = this.server + '/api2/repos/' + repoID + '/group-folder-perm/';
      var form = new _formData["default"]();
      form.append('permission', permission);
      form.append('folder_path', folderPath);
      form.append('group_id', groupID);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "updateGroupFolderPerm",
    value: function updateGroupFolderPerm(repoID, permission, folderPath, groupID) {
      var url = this.server + '/api2/repos/' + repoID + '/group-folder-perm/';
      var form = new _formData["default"]();
      form.append('permission', permission);
      form.append('folder_path', folderPath);
      form.append('group_id', groupID);
      return this.req.put(url, form);
    }
  }, {
    key: "deleteGroupFolderPerm",
    value: function deleteGroupFolderPerm(repoID, permission, folderPath, groupID) {
      var url = this.server + '/api2/repos/' + repoID + '/group-folder-perm/';
      var param = {
        permission: permission,
        folder_path: folderPath,
        group_id: groupID
      };
      return this.req["delete"](url, {
        data: param
      });
    }
  }, {
    key: "listDepartmentRepoUserFolderPerm",
    value: function listDepartmentRepoUserFolderPerm(repoID, folderPath) {
      var url = this.server + '/api/v2.1/group-owned-libraries/' + repoID + '/user-folder-permission/';

      if (folderPath) {
        url = url + '?folder_path=' + encodeURIComponent(folderPath);
      }

      return this.req.get(url);
    }
  }, {
    key: "addDepartmentRepoUserFolderPerm",
    value: function addDepartmentRepoUserFolderPerm(repoID, permission, folderPath, userEmail) {
      var url = this.server + '/api/v2.1/group-owned-libraries/' + repoID + '/user-folder-permission/';
      var form = new _formData["default"]();
      form.append('permission', permission);
      form.append('folder_path', folderPath);

      if (Array.isArray(userEmail)) {
        userEmail.forEach(function (item) {
          form.append('user_email', item);
        });
      } else {
        form.append('user_email', userEmail);
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "updateDepartmentRepoUserFolderPerm",
    value: function updateDepartmentRepoUserFolderPerm(repoID, permission, folderPath, userEmail) {
      var url = this.server + '/api/v2.1/group-owned-libraries/' + repoID + '/user-folder-permission/';
      var form = new _formData["default"]();
      form.append('permission', permission);
      form.append('folder_path', folderPath);
      form.append('user_email', userEmail);
      return this.req.put(url, form);
    }
  }, {
    key: "deleteDepartmentRepoUserFolderPerm",
    value: function deleteDepartmentRepoUserFolderPerm(repoID, permission, folderPath, userEmail) {
      var url = this.server + '/api/v2.1/group-owned-libraries/' + repoID + '/user-folder-permission/';
      var param = {
        permission: permission,
        folder_path: folderPath,
        user_email: userEmail
      };
      return this.req["delete"](url, {
        data: param
      });
    }
  }, {
    key: "listDepartmentRepoGroupFolderPerm",
    value: function listDepartmentRepoGroupFolderPerm(repoID, folderPath) {
      var url = this.server + '/api/v2.1/group-owned-libraries/' + repoID + '/group-folder-permission/';

      if (folderPath) {
        url = url + '?folder_path=' + encodeURIComponent(folderPath);
      }

      return this.req.get(url);
    }
  }, {
    key: "addDepartmentRepoGroupFolderPerm",
    value: function addDepartmentRepoGroupFolderPerm(repoID, permission, folderPath, groupID) {
      var url = this.server + '/api/v2.1/group-owned-libraries/' + repoID + '/group-folder-permission/';
      var form = new _formData["default"]();
      form.append('permission', permission);
      form.append('folder_path', folderPath);
      form.append('group_id', groupID);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "updateDepartmentRepoGroupFolderPerm",
    value: function updateDepartmentRepoGroupFolderPerm(repoID, permission, folderPath, groupID) {
      var url = this.server + '/api/v2.1/group-owned-libraries/' + repoID + '/group-folder-permission/';
      var form = new _formData["default"]();
      form.append('permission', permission);
      form.append('folder_path', folderPath);
      form.append('group_id', groupID);
      return this.req.put(url, form);
    }
  }, {
    key: "deleteDepartmentRepoGroupFolderPerm",
    value: function deleteDepartmentRepoGroupFolderPerm(repoID, permission, folderPath, groupID) {
      var url = this.server + '/api/v2.1/group-owned-libraries/' + repoID + '/group-folder-permission/';
      var param = {
        permission: permission,
        folder_path: folderPath,
        group_id: groupID
      };
      return this.req["delete"](url, {
        data: param
      });
    }
  }, {
    key: "adminListWorkWeixinDepartments",
    value: function adminListWorkWeixinDepartments(departmentID) {
      var url = this.server + '/api/v2.1/admin/work-weixin/departments/';
      var params = {};

      if (departmentID) {
        params.department_id = departmentID;
      }

      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "adminListWorkWeixinDepartmentMembers",
    value: function adminListWorkWeixinDepartmentMembers(departmentID, params) {
      var url = this.server + '/api/v2.1/admin/work-weixin/departments/' + departmentID + '/members/';
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "adminAddWorkWeixinUsersBatch",
    value: function adminAddWorkWeixinUsersBatch(userList) {
      var url = this.server + '/api/v2.1/admin/work-weixin/users/batch/';
      return this.req.post(url, {
        userlist: userList
      });
    }
  }, {
    key: "adminImportWorkWeixinDepartment",
    value: function adminImportWorkWeixinDepartment(departmentID) {
      var url = this.server + '/api/v2.1/admin/work-weixin/departments/import/';
      return this.req.post(url, {
        work_weixin_department_id: departmentID
      });
    }
  }, {
    key: "adminListDingtalkDepartments",
    value: function adminListDingtalkDepartments(departmentID) {
      var url = this.server + '/api/v2.1/admin/dingtalk/departments/';
      var params = {};

      if (departmentID) {
        params.department_id = departmentID;
      }

      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "adminListDingtalkDepartmentMembers",
    value: function adminListDingtalkDepartmentMembers(departmentID) {
      var url = this.server + '/api/v2.1/admin/dingtalk/departments/' + departmentID + '/members/';
      return this.req.get(url);
    }
  }, {
    key: "adminAddDingtalkUsersBatch",
    value: function adminAddDingtalkUsersBatch(userList) {
      var url = this.server + '/api/v2.1/admin/dingtalk/users/batch/';
      return this.req.post(url, {
        userlist: userList
      });
    }
  }, {
    key: "adminImportDingtalkDepartment",
    value: function adminImportDingtalkDepartment(departmentID) {
      var url = this.server + '/api/v2.1/admin/dingtalk/departments/import/';
      return this.req.post(url, {
        department_id: departmentID
      });
    }
  }, {
    key: "getRepoHistory",
    value: function getRepoHistory(repoID, page, perPage) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/history/';
      var params = {
        page: page || 1,
        per_page: perPage || 100
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "getCommitDetails",
    value: function getCommitDetails(repoID, commitID) {
      var url = this.server + '/ajax/repo/' + repoID + '/history/changes/';
      var params = {
        commit_id: commitID
      };
      return this.req.get(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        params: params
      });
    }
  }, {
    key: "getRepoFolderTrash",
    value: function getRepoFolderTrash(repoID, path, scanStat) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/trash/';
      var params = {
        path: path
      };

      if (scanStat) {
        params.scan_stat = scanStat;
      }

      return this.req.post(url, params);
    }
  }, {
    key: "deleteRepoTrash",
    value: function deleteRepoTrash(repoID, days) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/trash/';
      var params = {
        keep_days: days
      };
      return this.req["delete"](url, {
        data: params
      });
    }
  }, {
    key: "restoreFolder",
    value: function restoreFolder(repoID, commitID, path) {
      var url = this.server + '/api2/repos/' + repoID + '/dir/revert/';
      var data = {
        'commit_id': commitID,
        'p': path
      };
      return this.req.put(url, data);
    }
  }, {
    key: "restoreFile",
    value: function restoreFile(repoID, commitID, path) {
      var url = this.server + '/api2/repos/' + repoID + '/file/revert/';
      var data = {
        'commit_id': commitID,
        'p': path
      };
      return this.req.put(url, data);
    }
  }, {
    key: "listCommitDir",
    value: function listCommitDir(repoID, commitID, path) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/commits/' + commitID + '/dir/';
      var params = {
        path: path
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "listRepoRelatedUsers",
    value: function listRepoRelatedUsers(repoID) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/related-users/';
      return this.req.get(url);
    }
  }, {
    key: "listFileParticipants",
    value: function listFileParticipants(repoID, filePath) {
      var path = encodeURIComponent(filePath);
      var url = this.server + '/api/v2.1/repos/' + repoID + '/file/participants/?path=' + path;
      return this.req.get(url);
    }
  }, {
    key: "addFileParticipants",
    value: function addFileParticipants(repoID, filePath, emails) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/file/participants/';
      var params = {
        path: filePath,
        emails: emails
      };
      return this.req.post(url, params);
    }
  }, {
    key: "deleteFileParticipant",
    value: function deleteFileParticipant(repoID, filePath, email) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/file/participant/';
      var params = {
        path: filePath,
        email: email
      };
      return this.req["delete"](url, {
        data: params
      });
    }
  }, {
    key: "listOCMSharesPrepare",
    value: function listOCMSharesPrepare(repoId) {
      var url = this.server + '/api/v2.1/ocm/shares-prepare/';

      if (repoId) {
        url += '?repo_id=' + repoId;
      }

      return this.req.get(url);
    }
  }, {
    key: "addOCMSharePrepare",
    value: function addOCMSharePrepare(toUser, toServerURL, repoId, path, permission) {
      var url = this.server + '/api/v2.1/ocm/shares-prepare/';
      var params = {
        'to_user': toUser,
        'to_server_url': toServerURL,
        'repo_id': repoId,
        'path': path,
        'permission': permission
      };
      return this.req.post(url, params);
    }
  }, {
    key: "deleteOCMSharePrepare",
    value: function deleteOCMSharePrepare(id) {
      var url = this.server + '/api/v2.1/ocm/shares-prepare/' + id + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "listOCMSharesReceived",
    value: function listOCMSharesReceived() {
      var url = this.server + '/api/v2.1/ocm/shares-received/';
      return this.req.get(url);
    }
  }, {
    key: "deleteOCMShareReceived",
    value: function deleteOCMShareReceived(id) {
      var url = this.server + '/api/v2.1/ocm/shares-received/' + id + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "listOCMRepoDir",
    value: function listOCMRepoDir(providerID, repoID, path) {
      var url = this.server + '/api/v2.1/ocm/providers/' + providerID + '/repos/' + repoID + '/dir/?path=' + encodeURIComponent(path);
      return this.req.get(url);
    }
  }, {
    key: "getOCMRepoDownloadURL",
    value: function getOCMRepoDownloadURL(providerID, repoID, path) {
      var url = this.server + '/api/v2.1/ocm/providers/' + providerID + '/repos/' + repoID + '/download-link/?path=' + encodeURIComponent(path);
      return this.req.get(url);
    }
  }, {
    key: "getOCMRepoUploadURL",
    value: function getOCMRepoUploadURL(providerID, repoID, path) {
      var url = this.server + '/api/v2.1/ocm/providers/' + providerID + '/repos/' + repoID + '/upload-link/?path=' + encodeURIComponent(path);
      return this.req.get(url);
    }
  }, {
    key: "getRepoOldFilesAutoDelDays",
    value: function getRepoOldFilesAutoDelDays(repoID) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/auto-delete/';
      return this.req.get(url);
    }
  }, {
    key: "setRepoOldFilesAutoDelDays",
    value: function setRepoOldFilesAutoDelDays(repoID, autoDelDays) {
      var url = this.server + '/api/v2.1/repos/' + repoID + '/auto-delete/';
      var formData = new _formData["default"]();
      formData.append('auto_delete_days', autoDelDays);
      return this.req.put(url, formData);
    }
  }, {
    key: "sysAdminUploadLicense",
    value: function sysAdminUploadLicense(file) {
      var url = this.server + '/api/v2.1/admin/license/';
      var formData = new _formData["default"]();
      formData.append('license', file);
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "sysAdminGetSysInfo",
    value: function sysAdminGetSysInfo() {
      var url = this.server + '/api/v2.1/admin/sysinfo/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminListDevices",
    value: function sysAdminListDevices(platform, page, per_page) {
      var url = this.server + '/api/v2.1/admin/devices/';
      var params = {
        platform: platform,
        page: page,
        per_page: per_page
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminUnlinkDevice",
    value: function sysAdminUnlinkDevice(platform, deviceID, user, wipeDevice) {
      var url = this.server + '/api/v2.1/admin/devices/';
      var params = {
        wipe_device: wipeDevice ? 'true' : 'false',
        platform: platform,
        device_id: deviceID,
        user: user
      };
      return this.req["delete"](url, {
        data: params
      });
    }
  }, {
    key: "sysAdminListDeviceErrors",
    value: function sysAdminListDeviceErrors(page, per_page) {
      var url = this.server + '/api/v2.1/admin/device-errors/';
      var params = {
        page: page,
        per_page: per_page
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminClearDeviceErrors",
    value: function sysAdminClearDeviceErrors() {
      var url = this.server + '/api/v2.1/admin/device-errors/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminGetSysSettingInfo",
    value: function sysAdminGetSysSettingInfo() {
      var url = this.server + '/api/v2.1/admin/web-settings/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminSetSysSettingInfo",
    value: function sysAdminSetSysSettingInfo(key, value) {
      var url = this.server + '/api/v2.1/admin/web-settings/';
      var formData = new _formData["default"]();
      formData.append(key, value);
      return this.req.put(url, formData);
    }
  }, {
    key: "sysAdminUpdateLogo",
    value: function sysAdminUpdateLogo(file) {
      var url = this.server + '/api/v2.1/admin/logo/';
      var formData = new _formData["default"]();
      formData.append('logo', file);
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "sysAdminUpdateFavicon",
    value: function sysAdminUpdateFavicon(file) {
      var url = this.server + '/api/v2.1/admin/favicon/';
      var formData = new _formData["default"]();
      formData.append('favicon', file);
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "sysAdminUpdateLoginBG",
    value: function sysAdminUpdateLoginBG(file) {
      var url = this.server + '/api/v2.1/admin/login-background-image/';
      var formData = new _formData["default"]();
      formData.append('login_bg_image', file);
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "sysAdminListAllRepos",
    value: function sysAdminListAllRepos(page, perPage, orderBy) {
      var url = this.server + '/api/v2.1/admin/libraries/';
      var params = {
        page: page,
        per_page: perPage
      };

      if (orderBy) {
        params.order_by = orderBy;
      }

      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminSearchRepos",
    value: function sysAdminSearchRepos(name) {
      var url = this.server + '/api/v2.1/admin/search-library/';
      var params = {
        query: name || ''
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminGetSystemRepoInfo",
    value: function sysAdminGetSystemRepoInfo() {
      var url = this.server + '/api/v2.1/admin/system-library/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminDeleteRepo",
    value: function sysAdminDeleteRepo(repoID) {
      var url = this.server + '/api/v2.1/admin/libraries/' + repoID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminTransferRepo",
    value: function sysAdminTransferRepo(repoID, userEmail) {
      var url = this.server + '/api/v2.1/admin/libraries/' + repoID + '/';
      var params = {
        owner: userEmail
      };
      return this.req.put(url, params);
    }
  }, {
    key: "sysAdminGetRepoHistorySetting",
    value: function sysAdminGetRepoHistorySetting(repoID) {
      var url = this.server + '/api/v2.1/admin/libraries/' + repoID + '/history-limit/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminUpdateRepoHistorySetting",
    value: function sysAdminUpdateRepoHistorySetting(repoID, keepDays) {
      var url = this.server + '/api/v2.1/admin/libraries/' + repoID + '/history-limit/';
      var form = new _formData["default"]();
      form.append('keep_days', keepDays);
      return this.req.put(url, form);
    }
  }, {
    key: "sysAdminListRepoSharedItems",
    value: function sysAdminListRepoSharedItems(repoID, shareType) {
      var url = this.server + '/api/v2.1/admin/shares/';
      var params = {
        repo_id: repoID,
        share_type: shareType
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminUpdateRepoSharedItemPermission",
    value: function sysAdminUpdateRepoSharedItemPermission(repoID, shareType, shareTo, permission) {
      var url = this.server + '/api/v2.1/admin/shares/';
      var params = {
        repo_id: repoID,
        share_type: shareType,
        permission: permission,
        share_to: shareTo
      };
      return this.req.put(url, params);
    }
  }, {
    key: "sysAdminAddRepoSharedItem",
    value: function sysAdminAddRepoSharedItem(repoID, shareType, shareToList, permission) {
      var url = this.server + '/api/v2.1/admin/shares/';
      var form = new _formData["default"]();
      form.append('repo_id', repoID);
      form.append('share_type', shareType);
      form.append('permission', permission);
      shareToList.map(function (shareTo) {
        form.append('share_to', shareTo);
      });
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "sysAdminDeleteRepoSharedItem",
    value: function sysAdminDeleteRepoSharedItem(repoID, shareType, shareTo) {
      var url = this.server + '/api/v2.1/admin/shares/';
      var params = {
        repo_id: repoID,
        share_type: shareType,
        share_to: shareTo
      };
      return this.req["delete"](url, {
        data: params
      });
    }
  }, {
    key: "sysAdminCreateRepo",
    value: function sysAdminCreateRepo(repoName, owner) {
      var url = this.server + '/api/v2.1/admin/libraries/';
      var form = new _formData["default"]();
      form.append('name', repoName);
      form.append('owner', owner);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "sysAdminListTrashRepos",
    value: function sysAdminListTrashRepos(page, perPage) {
      var url = this.server + '/api/v2.1/admin/trash-libraries/';
      var params = {
        page: page,
        per_page: perPage
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminSearchTrashRepos",
    value: function sysAdminSearchTrashRepos(owner) {
      var url = this.server + '/api/v2.1/admin/trash-libraries/';
      var params = {
        owner: owner || ''
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminDeleteTrashRepo",
    value: function sysAdminDeleteTrashRepo(repoID) {
      var url = this.server + '/api/v2.1/admin/trash-libraries/' + repoID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminRestoreTrashRepo",
    value: function sysAdminRestoreTrashRepo(repoID) {
      var url = this.server + '/api/v2.1/admin/trash-libraries/' + repoID + '/';
      return this.req.put(url);
    }
  }, {
    key: "sysAdminCleanTrashRepos",
    value: function sysAdminCleanTrashRepos() {
      var url = this.server + '/api/v2.1/admin/trash-libraries/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminListRepoDirents",
    value: function sysAdminListRepoDirents(repoID, dir) {
      var url = this.server + '/api/v2.1/admin/libraries/' + repoID + '/dirents/';
      var params = {
        parent_dir: dir
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminDeleteRepoDirent",
    value: function sysAdminDeleteRepoDirent(repoID, path) {
      var url = this.server + '/api/v2.1/admin/libraries/' + repoID + '/dirent/';
      var params = {
        path: path
      };
      return this.req["delete"](url, {
        params: params
      });
    }
  }, {
    key: "sysAdminGetRepoFileDownloadURL",
    value: function sysAdminGetRepoFileDownloadURL(repoID, path) {
      var url = this.server + '/api/v2.1/admin/libraries/' + repoID + '/dirent/';
      var params = {
        path: path,
        dl: 1
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sydAdminGetSysRepoItemUploadURL",
    value: function sydAdminGetSysRepoItemUploadURL(path) {
      var url = this.server + '/api/v2.1/admin/system-library/upload-link/?from=web';
      var params = {
        path: path
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminGetSysRepoItemInfo",
    value: function sysAdminGetSysRepoItemInfo(repoID, path) {
      var url = this.server + '/api/v2.1/admin/libraries/' + repoID + '/dirent/';
      var params = {
        path: path
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminCreateSysRepoFolder",
    value: function sysAdminCreateSysRepoFolder(repoID, path, name) {
      var url = this.server + '/api/v2.1/admin/libraries/' + repoID + '/dirents/?parent_dir=' + encodeURIComponent(path);
      var form = new _formData["default"]();
      form.append('obj_name', name);
      return this._sendPostRequest(url, form);
    }
  }, {
    key: "sysAdminListAllGroups",
    value: function sysAdminListAllGroups(page, perPage) {
      var url = this.server + '/api/v2.1/admin/groups/';
      var params = {
        page: page,
        per_page: perPage
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminSearchGroups",
    value: function sysAdminSearchGroups(name) {
      var url = this.server + '/api/v2.1/admin/search-group/';
      var params = {
        query: name
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminDismissGroupByID",
    value: function sysAdminDismissGroupByID(groupID) {
      var url = this.server + '/api/v2.1/admin/groups/' + groupID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminTransferGroup",
    value: function sysAdminTransferGroup(receiverEmail, groupID) {
      var url = this.server + '/api/v2.1/admin/groups/' + groupID + '/';
      var formData = new _formData["default"]();
      formData.append('new_owner', receiverEmail);
      return this.req.put(url, formData);
    }
  }, {
    key: "sysAdminCreateNewGroup",
    value: function sysAdminCreateNewGroup(groupName, ownerEmail) {
      var url = this.server + '/api/v2.1/admin/groups/';
      var formData = new _formData["default"]();
      formData.append('group_name', groupName);
      formData.append('group_owner', ownerEmail);
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "sysAdminListGroupRepos",
    value: function sysAdminListGroupRepos(groupID) {
      var url = this.server + '/api/v2.1/admin/groups/' + groupID + '/libraries/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminListGroupMembers",
    value: function sysAdminListGroupMembers(groupID, page, perPage) {
      var url = this.server + '/api/v2.1/admin/groups/' + groupID + '/members/';
      var params = {
        page: page,
        per_page: perPage
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminUnshareRepoFromGroup",
    value: function sysAdminUnshareRepoFromGroup(groupID, repoID) {
      var url = this.server + '/api/v2.1/admin/groups/' + groupID + '/libraries/' + repoID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminAddGroupMember",
    value: function sysAdminAddGroupMember(groupID, emails) {
      var url = this.server + '/api/v2.1/admin/groups/' + groupID + '/members/';
      var form = new _formData["default"]();

      for (var i = 0; i < emails.length; i++) {
        form.append('email', emails[i]);
      }

      return this._sendPostRequest(url, form);
    }
  }, {
    key: "sysAdminDeleteGroupMember",
    value: function sysAdminDeleteGroupMember(groupID, email) {
      var url = this.server + '/api/v2.1/admin/groups/' + groupID + '/members/' + encodeURIComponent(email) + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminUpdateGroupMemberRole",
    value: function sysAdminUpdateGroupMemberRole(groupID, email, isAdmin) {
      var url = this.server + '/api/v2.1/admin/groups/' + groupID + '/members/' + encodeURIComponent(email) + '/';
      var formData = new _formData["default"]();
      formData.append('is_admin', isAdmin);
      return this.req.put(url, formData);
    }
  }, {
    key: "sysAdminListAllSysNotifications",
    value: function sysAdminListAllSysNotifications() {
      var url = this.server + '/api/v2.1/admin/sys-notifications/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminAddSysNotification",
    value: function sysAdminAddSysNotification(msg) {
      var url = this.server + '/api/v2.1/admin/sys-notifications/';
      var formData = new _formData["default"]();
      formData.append('msg', msg);
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "sysAdminSetSysNotificationToCurrent",
    value: function sysAdminSetSysNotificationToCurrent(nid) {
      var url = this.server + '/api/v2.1/admin/sys-notifications/' + nid + '/';
      return this.req.put(url);
    }
  }, {
    key: "sysAdminDeleteSysNotification",
    value: function sysAdminDeleteSysNotification(nid) {
      var url = this.server + '/api/v2.1/admin/sys-notifications/' + nid + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminListAllDepartments",
    value: function sysAdminListAllDepartments() {
      var url = this.server + '/api/v2.1/admin/address-book/groups/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminAddNewDepartment",
    value: function sysAdminAddNewDepartment(parentGroupID, groupName) {
      var url = this.server + '/api/v2.1/admin/address-book/groups/';
      var formData = new _formData["default"]();
      formData.append('parent_group', parentGroupID);
      formData.append('group_name', groupName);
      formData.append('group_owner', 'system admin');
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "sysAdminGetDepartmentInfo",
    value: function sysAdminGetDepartmentInfo(groupID, showAncestors) {
      var url = this.server + '/api/v2.1/admin/address-book/groups/' + groupID + '/';
      url += showAncestors ? '?return_ancestors=true' : '';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminUpdateDepartmentQuota",
    value: function sysAdminUpdateDepartmentQuota(groupID, quota) {
      var url = this.server + '/api/v2.1/admin/groups/' + groupID + '/';
      var formData = new _formData["default"]();
      formData.append('quota', quota);
      return this.req.put(url, formData);
    }
  }, {
    key: "sysAdminRenameDepartment",
    value: function sysAdminRenameDepartment(groupID, groupName) {
      var url = this.server + '/api/v2.1/admin/groups/' + groupID + '/';
      var formData = new _formData["default"]();
      formData.append('name', groupName);
      return this.req.put(url, formData);
    }
  }, {
    key: "sysAdminDeleteDepartment",
    value: function sysAdminDeleteDepartment(groupID) {
      var url = this.server + '/api/v2.1/admin/address-book/groups/' + groupID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminAddRepoInDepartment",
    value: function sysAdminAddRepoInDepartment(groupID, repoName) {
      var url = this.server + '/api/v2.1/admin/groups/' + groupID + '/group-owned-libraries/';
      var formData = new _formData["default"]();
      formData.append('repo_name', repoName);
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "sysAdminDeleteRepoInDepartment",
    value: function sysAdminDeleteRepoInDepartment(groupID, repoID) {
      var url = this.server + '/api/v2.1/admin/groups/' + groupID + '/group-owned-libraries/' + repoID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminListShareLinks",
    value: function sysAdminListShareLinks(page, perPage, sortBy, sortOrder) {
      var url = this.server + '/api/v2.1/admin/share-links/';
      var params = {
        page: page,
        per_page: perPage
      };

      if (sortBy) {
        params.order_by = sortBy;
        params.direction = sortOrder;
      }

      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminDeleteShareLink",
    value: function sysAdminDeleteShareLink(token) {
      var url = this.server + '/api/v2.1/admin/share-links/' + token + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminListAllUploadLinks",
    value: function sysAdminListAllUploadLinks(page, perPage) {
      var url = this.server + '/api/v2.1/admin/upload-links/';
      var params = {
        page: page,
        per_page: perPage
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminDeleteUploadLink",
    value: function sysAdminDeleteUploadLink(token) {
      var url = this.server + '/api/v2.1/admin/upload-links/' + token + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminListOrgs",
    value: function sysAdminListOrgs(page, perPage) {
      var url = this.server + '/api/v2.1/admin/organizations/';
      var params = {
        page: page,
        per_page: perPage
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminSearchOrgs",
    value: function sysAdminSearchOrgs(name) {
      var url = this.server + '/api/v2.1/admin/search-organization/';
      var params = {
        query: name
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminGetOrg",
    value: function sysAdminGetOrg(orgID) {
      var url = this.server + '/api/v2.1/admin/organizations/' + orgID + '/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminUpdateOrg",
    value: function sysAdminUpdateOrg(orgID, orgInfo) {
      var url = this.server + '/api/v2.1/admin/organizations/' + orgID + '/';
      var formData = new _formData["default"]();

      if (orgInfo.orgName) {
        formData.append('org_name', orgInfo.orgName);
      }

      if (orgInfo.maxUserNumber) {
        formData.append('max_user_number', orgInfo.maxUserNumber);
      }

      if (orgInfo.quota) {
        formData.append('quota', orgInfo.quota);
      }

      if (orgInfo.role) {
        formData.append('role', orgInfo.role);
      }

      return this.req.put(url, formData);
    }
  }, {
    key: "sysAdminAddOrg",
    value: function sysAdminAddOrg(orgName, ownerEmail, owner_password) {
      var url = this.server + '/api/v2.1/admin/organizations/';
      var formData = new _formData["default"]();
      formData.append('org_name', orgName);
      formData.append('owner_email', ownerEmail);
      formData.append('owner_password', owner_password);
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "sysAdminDeleteOrg",
    value: function sysAdminDeleteOrg(orgID) {
      var url = this.server + '/api/v2.1/admin/organizations/' + orgID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminListOrgUsers",
    value: function sysAdminListOrgUsers(orgID) {
      var url = this.server + '/api/v2.1/admin/organizations/' + orgID + '/users/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminAddOrgUser",
    value: function sysAdminAddOrgUser(orgID, email, name, password) {
      var url = this.server + '/api/v2.1/admin/organizations/' + orgID + '/users/';
      var formData = new _formData["default"]();
      formData.append('email', email);
      formData.append('name', name);
      formData.append('password', password);
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "sysAdminUpdateOrgUser",
    value: function sysAdminUpdateOrgUser(orgID, email, attribute, value) {
      var url = this.server + '/api/v2.1/admin/organizations/' + orgID + '/users/' + encodeURIComponent(email) + '/';
      var formData = new _formData["default"]();

      switch (attribute) {
        case 'active':
          formData.append('active', value);
          break;

        case 'is_org_staff':
          formData.append('is_org_staff', value);
          break;

        case 'name':
          formData.append('name', value);
          break;

        case 'contact_email':
          formData.append('contact_email', value);
          break;

        case 'quota_total':
          formData.append('quota_total', value);
          break;
      }

      return this.req.put(url, formData);
    }
  }, {
    key: "sysAdminDeleteOrgUser",
    value: function sysAdminDeleteOrgUser(orgID, email) {
      var url = this.server + '/api/v2.1/admin/organizations/' + orgID + '/users/' + encodeURIComponent(email) + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminListOrgGroups",
    value: function sysAdminListOrgGroups(orgID) {
      var url = this.server + '/api/v2.1/admin/organizations/' + orgID + '/groups/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminListOrgRepos",
    value: function sysAdminListOrgRepos(orgID) {
      var url = this.server + '/api/v2.1/admin/organizations/' + orgID + '/repos/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminListLoginLogs",
    value: function sysAdminListLoginLogs(page, perPage) {
      var url = this.server + '/api/v2.1/admin/logs/login-logs/';
      var params = {
        page: page,
        per_page: perPage
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminListFileAccessLogs",
    value: function sysAdminListFileAccessLogs(page, perPage, email, repoID) {
      var url = this.server + '/api/v2.1/admin/logs/file-access-logs/';
      var params = {
        page: page,
        per_page: perPage
      };

      if (email != undefined) {
        params.email = email;
      }

      if (repoID != undefined) {
        params.repo_id = repoID;
      }

      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminListFileUpdateLogs",
    value: function sysAdminListFileUpdateLogs(page, perPage) {
      var url = this.server + '/api/v2.1/admin/logs/file-update-logs/';
      var params = {
        page: page,
        per_page: perPage
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminListSharePermissionLogs",
    value: function sysAdminListSharePermissionLogs(page, perPage) {
      var url = this.server + '/api/v2.1/admin/logs/share-permission-logs/';
      var params = {
        page: page,
        per_page: perPage
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminListAdminLogs",
    value: function sysAdminListAdminLogs(page, perPage) {
      var url = this.server + '/api/v2.1/admin/admin-logs/';
      var params = {
        page: page,
        per_page: perPage
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminListAdminLoginLogs",
    value: function sysAdminListAdminLoginLogs(page, perPage) {
      var url = this.server + '/api/v2.1/admin/admin-login-logs/';
      var params = {
        page: page,
        per_page: perPage
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminListShareInRepos",
    value: function sysAdminListShareInRepos(receiverEmail) {
      var url = this.server + '/api/v2.1/admin/users/' + encodeURIComponent(receiverEmail) + '/beshared-repos/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminListShareLinksByUser",
    value: function sysAdminListShareLinksByUser(email) {
      var url = this.server + '/api/v2.1/admin/users/' + encodeURIComponent(email) + '/share-links/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminListUploadLinksByUser",
    value: function sysAdminListUploadLinksByUser(email) {
      var url = this.server + '/api/v2.1/admin/users/' + encodeURIComponent(email) + '/upload-links/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminListGroupsJoinedByUser",
    value: function sysAdminListGroupsJoinedByUser(email) {
      var url = this.server + '/api/v2.1/admin/users/' + encodeURIComponent(email) + '/groups/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminSetForceTwoFactorAuth",
    value: function sysAdminSetForceTwoFactorAuth(email, isForce2FA) {
      var isForce = isForce2FA ? 1 : 0;
      var url = this.server + '/api2/two-factor-auth/' + encodeURIComponent(email) + '/';
      var formData = new _formData["default"]();
      formData.append('force_2fa', isForce);
      return this.req.put(url, formData);
    }
  }, {
    key: "sysAdminDeleteTwoFactorAuth",
    value: function sysAdminDeleteTwoFactorAuth(email) {
      var url = this.server + '/api2/two-factor-auth/' + encodeURIComponent(email) + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminListUsers",
    value: function sysAdminListUsers(page, perPage, isLDAPImported, sortBy, sortOrder) {
      var url = this.server + '/api/v2.1/admin/users/';
      var params = {
        page: page,
        per_page: perPage
      };

      if (isLDAPImported) {
        params.source = 'LDAPImport';
      }

      if (sortBy) {
        params.order_by = sortBy;
        params.direction = sortOrder;
      }

      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminSearchUsers",
    value: function sysAdminSearchUsers(query, page, perPage) {
      var url = this.server + '/api/v2.1/admin/search-user/';
      var params = {
        query: query,
        page: page,
        per_page: perPage
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminListLDAPUsers",
    value: function sysAdminListLDAPUsers(page, perPage) {
      var url = this.server + '/api/v2.1/admin/ldap-users/';
      var params = {
        page: page,
        per_page: perPage
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminAddUser",
    value: function sysAdminAddUser(email, name, role, password) {
      var url = this.server + '/api/v2.1/admin/users/';
      var formData = new _formData["default"]();
      formData.append('email', email);
      formData.append('name', name);
      formData.append('password', password);

      if (role) {
        formData.append('role', role);
      }

      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "sysAdminUpdateUser",
    value: function sysAdminUpdateUser(email, attribute, value) {
      var url = this.server + '/api/v2.1/admin/users/' + encodeURIComponent(email) + '/';
      var formData = new _formData["default"]();

      switch (attribute) {
        case 'password':
          formData.append('password', value);
          break;

        case 'is_active':
          formData.append('is_active', value);
          break;

        case 'is_staff':
          formData.append('is_staff', value);
          break;

        case 'role':
          formData.append('role', value);
          break;

        case 'name':
          formData.append('name', value);
          break;

        case 'login_id':
          formData.append('login_id', value);
          break;

        case 'contact_email':
          formData.append('contact_email', value);
          break;

        case 'reference_id':
          formData.append('reference_id', value);
          break;

        case 'department':
          formData.append('department', value);
          break;

        case 'quota_total':
          formData.append('quota_total', value);
          break;

        case 'institution':
          formData.append('institution', value);
          break;

        case 'upload_rate_limit':
          formData.append('upload_rate_limit', value);
          break;

        case 'download_rate_limit':
          formData.append('download_rate_limit', value);
          break;
      }

      return this.req.put(url, formData);
    }
  }, {
    key: "sysAdminDeleteUser",
    value: function sysAdminDeleteUser(email) {
      var url = this.server + '/api/v2.1/admin/users/' + encodeURIComponent(email) + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminGetUser",
    value: function sysAdminGetUser(email, avatarSize) {
      var url = this.server + '/api/v2.1/admin/users/' + encodeURIComponent(email) + '/';
      var params = {};

      if (avatarSize) {
        params.avatar_size = avatarSize;
      }

      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminResetUserPassword",
    value: function sysAdminResetUserPassword(email) {
      var url = this.server + '/api/v2.1/admin/users/' + encodeURIComponent(email) + '/reset-password/';
      return this.req.put(url);
    }
  }, {
    key: "sysAdminSetUserQuotaInBatch",
    value: function sysAdminSetUserQuotaInBatch(emails, quotaTotal) {
      var url = this.server + '/api/v2.1/admin/users/batch/';
      var formData = new _formData["default"]();
      emails.map(function (email) {
        formData.append('email', email);
      });
      formData.append('operation', 'set-quota');
      formData.append('quota_total', quotaTotal);
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "sysAdminDeleteUserInBatch",
    value: function sysAdminDeleteUserInBatch(emails) {
      var url = this.server + '/api/v2.1/admin/users/batch/';
      var formData = new _formData["default"]();
      emails.map(function (email) {
        formData.append('email', email);
      });
      formData.append('operation', 'delete-user');
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "sysAdminImportUserViaFile",
    value: function sysAdminImportUserViaFile(file) {
      var url = this.server + '/api/v2.1/admin/import-users/';
      var formData = new _formData["default"]();
      formData.append('file', file);
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "sysAdminListAdmins",
    value: function sysAdminListAdmins() {
      var url = this.server + '/api/v2.1/admin/admin-users/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminUpdateAdminRole",
    value: function sysAdminUpdateAdminRole(email, role) {
      var url = this.server + '/api/v2.1/admin/admin-role/';
      var formData = new _formData["default"]();
      formData.append('email', email);
      formData.append('role', role);
      return this.req.put(url, formData);
    }
  }, {
    key: "sysAdminAddAdminInBatch",
    value: function sysAdminAddAdminInBatch(emails) {
      var url = this.server + '/api/v2.1/admin/admin-users/batch/';
      var formData = new _formData["default"]();
      emails.map(function (email) {
        formData.append('email', email);
      });
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "sysAdminListReposByOwner",
    value: function sysAdminListReposByOwner(email) {
      var url = this.server + '/api/v2.1/admin/libraries/';
      var params = {
        owner: email
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminListInvitations",
    value: function sysAdminListInvitations(page, perPage) {
      var url = this.server + '/api/v2.1/admin/invitations/';
      var params = {
        page: page,
        per_page: perPage
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminDeleteInvitation",
    value: function sysAdminDeleteInvitation(token) {
      var url = this.server + '/api/v2.1/admin/invitations/' + token + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminDeleteExpiredInvitations",
    value: function sysAdminDeleteExpiredInvitations() {
      var url = this.server + '/api/v2.1/admin/invitations/?type=expired';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminListInstitutions",
    value: function sysAdminListInstitutions(page, perPage) {
      var url = this.server + '/api/v2.1/admin/institutions/';
      var params = {
        page: page,
        per_page: perPage
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminAddInstitution",
    value: function sysAdminAddInstitution(name) {
      var url = this.server + '/api/v2.1/admin/institutions/';
      var formData = new _formData["default"]();
      formData.append('name', name);
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "sysAdminDeleteInstitution",
    value: function sysAdminDeleteInstitution(institutionID) {
      var url = this.server + '/api/v2.1/admin/institutions/' + institutionID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminGetInstitution",
    value: function sysAdminGetInstitution(institutionID) {
      var url = this.server + '/api/v2.1/admin/institutions/' + institutionID + '/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminUpdateInstitution",
    value: function sysAdminUpdateInstitution(institutionID, quota) {
      var url = this.server + '/api/v2.1/admin/institutions/' + institutionID + '/';
      var formData = new _formData["default"]();
      formData.append('quota', quota);
      return this.req.put(url, formData);
    }
  }, {
    key: "sysAdminListInstitutionUsers",
    value: function sysAdminListInstitutionUsers(institutionID, page, perPage) {
      var url = this.server + '/api/v2.1/admin/institutions/' + institutionID + '/users/';
      var params = {
        page: page,
        per_page: perPage
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminListInstitutionAdmins",
    value: function sysAdminListInstitutionAdmins(institutionID) {
      var url = this.server + '/api/v2.1/admin/institutions/' + institutionID + '/users/';
      var params = {
        is_institution_admin: true
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminAddInstitutionUserBatch",
    value: function sysAdminAddInstitutionUserBatch(institutionID, emailArray) {
      var url = this.server + '/api/v2.1/admin/institutions/' + institutionID + '/users/';
      var formData = new _formData["default"]();
      emailArray.map(function (email) {
        formData.append('email', email);
      });
      return this.req.post(url, formData);
    }
  }, {
    key: "sysAdminUpdateInstitutionUser",
    value: function sysAdminUpdateInstitutionUser(institutionID, email, isInstitutionAdmin) {
      var url = this.server + '/api/v2.1/admin/institutions/' + institutionID + '/users/' + encodeURIComponent(email) + '/';
      var formData = new _formData["default"]();
      formData.append('is_institution_admin', isInstitutionAdmin);
      return this.req.put(url, formData);
    }
  }, {
    key: "sysAdminDeleteInstitutionUser",
    value: function sysAdminDeleteInstitutionUser(institutionID, email) {
      var url = this.server + '/api/v2.1/admin/institutions/' + institutionID + '/users/' + encodeURIComponent(email) + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "sysAdminListTermsAndConditions",
    value: function sysAdminListTermsAndConditions() {
      var url = this.server + '/api/v2.1/admin/terms-and-conditions/';
      return this.req.get(url);
    }
  }, {
    key: "sysAdminAddTermAndCondition",
    value: function sysAdminAddTermAndCondition(name, versionNumber, text, isActive) {
      var url = this.server + '/api/v2.1/admin/terms-and-conditions/';
      var formData = new _formData["default"]();
      formData.append('name', name);
      formData.append('version_number', versionNumber);
      formData.append('text', text);
      formData.append('is_active', isActive);
      return this._sendPostRequest(url, formData);
    }
  }, {
    key: "sysAdminUpdateTermAndCondition",
    value: function sysAdminUpdateTermAndCondition(termID, name, versionNumber, text, isActive) {
      var url = this.server + '/api/v2.1/admin/terms-and-conditions/' + termID + '/';
      var formData = new _formData["default"]();
      formData.append('name', name);
      formData.append('version_number', versionNumber);
      formData.append('text', text);
      formData.append('is_active', isActive);
      return this.req.put(url, formData);
    }
  }, {
    key: "sysAdminDeleteTermAndCondition",
    value: function sysAdminDeleteTermAndCondition(termID) {
      var url = this.server + '/api/v2.1/admin/terms-and-conditions/' + termID + '/';
      return this.req["delete"](url);
    } // patch 7.1

  }, {
    key: "listVirusScanRecords",
    value: function listVirusScanRecords(pageNum) {
      var url = this.server + '/api/v2.1/admin/virus-scan-records/?page=' + pageNum;
      return this.req.get(url);
    } // patch 7.1

  }, {
    key: "deleteVirusScanRecord",
    value: function deleteVirusScanRecord(virusID) {
      var url = this.server + '/api/v2.1/admin/virus-scan-records/' + virusID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "listVirusFiles",
    value: function listVirusFiles(page, perPage, hasHandled) {
      var url = this.server + '/api/v2.1/admin/virus-files/';
      var params = {
        page: page,
        per_page: perPage
      };

      if (hasHandled != undefined) {
        params.has_handled = hasHandled;
      }

      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "deleteVirusFile",
    value: function deleteVirusFile(virusID) {
      var url = this.server + '/api/v2.1/admin/virus-files/' + virusID + '/';
      return this.req["delete"](url);
    }
  }, {
    key: "toggleIgnoreVirusFile",
    value: function toggleIgnoreVirusFile(virusID, ignore) {
      var url = this.server + '/api/v2.1/admin/virus-files/' + virusID + '/';
      var formData = new _formData["default"]();
      formData.append('ignore', ignore);
      return this.req.put(url, formData);
    }
  }, {
    key: "batchProcessVirusFiles",
    value: function batchProcessVirusFiles(virusIDs, operation) {
      var url = this.server + '/api/v2.1/admin/virus-files/batch/';
      var formData = new _formData["default"]();

      for (var i = 0; i < virusIDs.length; i++) {
        formData.append('virus_ids', virusIDs[i]);
      }

      formData.append('operation', operation);
      return this.req.post(url, formData);
    }
  }, {
    key: "sysAdminStatisticFiles",
    value: function sysAdminStatisticFiles(startTime, endTime, groupBy) {
      var url = this.server + '/api/v2.1/admin/statistics/file-operations/';
      var params = {
        start: startTime,
        end: endTime,
        group_by: groupBy
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminStatisticStorages",
    value: function sysAdminStatisticStorages(startTime, endTime, groupBy) {
      var url = this.server + '/api/v2.1/admin/statistics/total-storage/';
      var params = {
        start: startTime,
        end: endTime,
        group_by: groupBy
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminStatisticActiveUsers",
    value: function sysAdminStatisticActiveUsers(startTime, endTime, groupBy) {
      var url = this.server + '/api/v2.1/admin/statistics/active-users/';
      var params = {
        start: startTime,
        end: endTime,
        group_by: groupBy
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminStatisticTraffic",
    value: function sysAdminStatisticTraffic(startTime, endTime, groupBy) {
      var url = this.server + '/api/v2.1/admin/statistics/system-traffic/';
      var params = {
        start: startTime,
        end: endTime,
        group_by: groupBy
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminListUserTraffic",
    value: function sysAdminListUserTraffic(month, page, perPage, orderBy) {
      var url = this.server + '/api/v2.1/admin/statistics/system-user-traffic/';
      var params = {
        month: month,
        page: page,
        per_page: perPage,
        order_by: orderBy
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "sysAdminListOrgTraffic",
    value: function sysAdminListOrgTraffic(month, page, perPage, orderBy) {
      var url = this.server + '/api/v2.1/admin/statistics/system-org-traffic/';
      var params = {
        month: month,
        page: page,
        per_page: perPage,
        order_by: orderBy
      };
      return this.req.get(url, {
        params: params
      });
    }
  }, {
    key: "onlyofficeConvert",
    value: function onlyofficeConvert(repoID, filePath) {
      var url = this.server + '/onlyoffice-api/convert/';
      var formData = new _formData["default"]();
      formData.append('repo_id', repoID);
      formData.append('file_path', filePath);
      return this._sendPostRequest(url, formData);
    }
  }]);

  return SeafileAPI;
}();

exports.SeafileAPI = SeafileAPI;